<template>
  <div
    id="tab-booking-fcl"
  >
    <el-form
      v-if="isFba"
      :disabled="readonly"
      class="section"
      style="flex-direction: row;"
    >
      <span style="display: flex;align-items: center;width: 64px">
        {{ $t('FbaJob.ValueAddedServices') }}
      </span>
      <el-checkbox-group v-model="selectedLocalAddedService" @change="addedServiceChangeHandler">
        <el-checkbox
          v-for="item in localAddedService"
          :key="item.code"
          :label="item.code"
          :disabled="item.code === 'signHBL' && form.mblOnly"
          style="margin-left: 8px;margin-right: 8px"
          @change="val => singleAddedServiceChangeHandler(val, item)"
        >
          {{ item.chineseName }}
        </el-checkbox>
      </el-checkbox-group>
      <el-checkbox v-if="isBookingNew" v-model="form.destinationPortService" style="margin-left: 8px;margin-right: 8px" no="destinationPortService" @change="destinationPortServiceChange">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
    </el-form>
    <el-form
      v-if="!isFba"
      :disabled="readonly"
      class="section"
      style="flex-direction: row;"
    >
      <el-checkbox v-model="form.booking" no="booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
      <el-checkbox
        v-model="form.customs"
        no="customs"
        style="margin-left: -20px;"
        @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
      >{{ $t('SeaExport.CustomsDeclaration') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.insure"
        no="isInsure"
        style="margin-left: -20px;"
      >{{ $t('SeaExport.InsureInfo') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.signMBL"
        no="signMBL"
        style="margin-left: -20px;"
        @change="pm.isMBLChange()"
      >MB/L
      </el-checkbox>
      <el-checkbox
        v-model="form.signHBL"
        no="signHBL"
        style="margin-left: -20px;"
        :disabled="form.mblOnly"
        @change="pm.isHBLChange()"
      >HB/L
      </el-checkbox>
      <el-checkbox v-model="form.virtualHBL" no="virtualHBL" style="margin-left: -20px;" @change="pm.virtualHblChange()">{{ $t('SeaExport.FormalHbl') }}</el-checkbox>
      <el-checkbox v-model="form.vgm" no="vgm" style="margin-left: -20px;">{{ $t('SeaExport.Vgm') }}</el-checkbox>
      <el-checkbox v-model="form.ams" no="ams" style="margin-left: -20px;">{{ $t('SeaExport.Anti_terrorismShipping') }}</el-checkbox>
      <el-checkbox v-model="form.hds" no="hds" style="margin-left: -20px;">HDS</el-checkbox>
      <el-checkbox v-model="form.comercialInspectation" no="comercialInspectation" style="margin-left: -20px;">{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
      <el-checkbox v-model="form.heating" no="heating" style="margin-left: -20px;">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
      <el-checkbox v-model="form.itmService" no="itmService" style="margin-left: -20px;">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
      <el-checkbox v-if="isBookingNew" v-model="form.destinationPortService" no="destinationPortService" style="margin-left: -20px;" @change="destinationPortServiceChange">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
      <el-checkbox v-model="form.manifest" no="manifest" style="margin-left: -20px;">{{ $t('SeaExport.Manifest') }}</el-checkbox>
      <el-checkbox v-model="form.seaRailwayTransportation" no="seaRailwayTransportation" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_SeaRailTransport') }}</el-checkbox>
    </el-form>
    <div style="width: fit-content">
      <div style="display: flex">
        <div v-if="this.$store.getters.tenantId === 889" class="section form-column">
          <micro-app
            name="child-vue2"
            :url="$store.getters.frontEndPluginUrl+'/item'"
            router-mode="pure"
            destroy
          />
        </div>
        <div v-else class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="133px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.ConsignInfo') }}</span>
            <el-form-item :label="$t('SeaExport.BusinessNo')">
              <el-input
                :value="form.jobNo"
                :disabled="true"
              />
            </el-form-item>
            <div v-if="this.$store.getters.tenantId === 889">
              <micro-app
                name="child-operation-date"
                :url="$store.getters.frontEndPluginUrl+'/operationDateItem'"
                router-mode="pure"
                destroy
                @datachange="operationDateDataChange"
              />
            </div>
            <div v-if="this.$store.getters.tenantId === 889">
              <micro-app
                name="child-sale-role-hide"
                :url="$store.getters.frontEndPluginUrl+'/saleRoleHideItem'"
                router-mode="pure"
                destroy
                @datachange="saleRoleHideDataChange"
              />
            </div>
            <div v-if="this.$store.getters.tenantId === 889">
              <micro-app
                name="child-operation-date-query"
                :url="$store.getters.frontEndPluginUrl+'/operationDateQuery'"
                router-mode="pure"
                destroy
                @datachange="operationDateQueryDataChange"
              />
            </div>
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => {
                    if (!p.statusEnabled) {
                      return false
                    }
                    return isFba ? p.fbaSea : p.seaExportEnabled
                  }"
                  :default-value="this.form.saleProductCode || ''"
                  @parentCallBack="p => {this.form.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  clearable
                  :default-value="this.form.fullOrInside || ''"
                  @parentCallBack="p => {this.form.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.ConsignationCompany') }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageB"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <img
                    :class="form.customerId&&readonly?'':'not-click'"
                    :src="sopPic"
                    width="18"
                    height="28"
                    class="sop-img"
                    style="padding: 5px 0;vertical-align: bottom; cursor: pointer"
                    @click="pm.sopChangeCustomerIdHandler()"
                  >
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageB"
                  :content="warningImageBTip"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-sales-company-select
                  v-if="!isFba"
                  ref="customerSelect"
                  no="customerId"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :method-params="{customer:true,companyLob:'seaExport',active:true}"
                  :check-credit="true"
                  :default-value="form.customerId||''"
                  :disabled="!customerEnabled"
                  :job="form"
                  style="flex: 1;"
                  :class="importDifferenceField.customerId ? 'red-border' : ''"
                  @parentCallBack="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
                />
                <cargo-company-select
                  v-if="isFba"
                  ref="customerSelect"
                  no="customerId"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :method-params="{customer:true,companyLob:'seaExport',active:true, fba:true}"
                  :check-credit="true"
                  :job="form"
                  :default-value="form.customerId||''"
                  :disabled="!customerEnabled"
                  style="flex: 1;"
                  :data-filter-function="fbaCustomerIdFilter"
                  @change="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerProperty')">
              <el-tooltip :content="customerTip" placement="bottom">
                <span
                  v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                  class="orange"
                >LV{{ customerLevel.level }}</span>
                <span
                  v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                  style="color:#D3A73B"
                >&nbsp;{{ customerLevel.customerName }}</span>
                <span
                  v-show="contractStatusLabel"
                  class="red"
                >&nbsp;({{ contractStatusLabel }})</span>
                <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
                <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
                  <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
                </span>
              </el-tooltip>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.ContactPerson')"
            >
              <div style="display: flex">
                <el-select
                  v-model="form.customerContact"
                  no="customerContact"
                  filterable
                  :allow-create="true"
                  :class="importDifferenceField.customerContact ? 'red-border' : ''"
                >
                  <el-option
                    v-for="(item,index) in contactList"
                    :key="index"
                    :label="item.contactPerson"
                    :value="item.contactPerson"
                  />
                </el-select>&nbsp;
                <el-link
                  v-show="!isShowContactPersonDetail"
                  no="customerContactLink"
                  :class="form.customerContact?'':'not-click'"
                  @click="showContactDialog"
                >{{ $t('SeaExport.Detail') }}
                </el-link>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FLCLType')">
              <el-select
                v-model="form.containerLoadType"
                no="containerLoadType"
                :disabled="!(isEdit && lclslaveEnabled)"
                :class="importDifferenceField.containerLoadType ? 'red-border' : ''"
                @change="val=>{pm.containerLoadTypeChange(val)}"
              >
                <el-option
                  v-for="(item,index) in (containerLoadTypes)"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <el-select v-model="form.cargoType" :class="importDifferenceField.cargoType ? 'red-border' : ''" filterable @change="val=>{cargoTypeChange(val)}">
                <el-option
                  v-for="(item,index) in cargoType4JobSelect"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input
                :value="form.salesChannel"
                :disabled="true"
              />
            </el-form-item>
            <!--CARGO-18489 新增“渠道单号”字段,显示渠道单号时隐藏委托关联号-->
            <el-form-item v-if="showChannelNo" :label="$t('SeaExport.ChannelNo')">
              <el-input :value="form.channelNo" :disabled="true" />
            </el-form-item>
            <el-form-item v-if="!showChannelNo" :label="$t('SeaExport.ConsignationRelationNumber')">
              <el-input :value="form.trustFromJob" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BusinessCommissionedRelationNumber')">
              <el-input :value="form.relatedJob" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.quotationNum')">
              <el-input :value="form.quotationNo" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingDate')">
              <el-date-picker
                v-model="form.bookingDate"
                no="bookingDate"
                :disabled="readonly"
                type="date"
                style="width:100%;"
                clearable
                :class="importDifferenceField.bookingDate ? 'red-border' : ''"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
              <div style="display: flex;">
                <el-date-picker
                  no="etd"
                  class="departure-date-picker"
                  :value="form.etd"
                  :disabled="(form.lclMasterUuid?true:!etdEnabled) || canEditInternalDelegatedJobField || !isJydEditJobFields || provisionEtdLocked"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1;margin-right: 5px"
                  :class="importDifferenceField.etd ? 'red-border' : ''"
                  @input="etdChange"
                />
                <span>{{ form.sailingDay|filterWeek }}</span>
              </div>
              <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.DateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.eta"
                  no="eta"
                  :disabled="!lclslaveEnabled || canEditInternalDelegatedJobField"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :class="importDifferenceField.eta ? 'red-border' : ''"
                  @input="etaChange"
                />
                <span>{{ form.etaSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  :value="form.atd"
                  no="atd"
                  :disabled="!lclslaveEnabled || canEditInternalDelegatedJobField"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="atdChange"
                />
                <span>{{ form.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.ata"
                  no="ata"
                  :disabled="!lclslaveEnabled || canEditInternalDelegatedJobField"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="ataChange"
                />
                <span>{{ form.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')">
              <el-date-picker
                v-model="form.customsDate"
                no="customsDate"
                type="date"
                :disabled="!isJydUpdateCustomsDate"
                style="width:100%"
                :class="importDifferenceField.customsDate ? 'red-border' : ''"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceiptCodeOnBl')">
              <cargo-advance-select
                no="dispatchingPlaceCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                :placeholder="$t('SeaExport.PlaceHolderPOR')"
                filterable
                :default-value="form.dispatchingPlaceCode"
                tag-name="englishName"
                style="flex:1"
                :class="importDifferenceField.dispatchingPlaceCode ? 'red-border' : ''"
                @parentCallBack="p=>{pm.changeDispatchingPlaceCode(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceiptOnBl')">
              <el-input
                v-model="form.dispatchingPlace"
                no="dispatchingPlace"
                :class="importDifferenceField.dispatchingPlace ? 'red-border' : ''"
                @change="pm.cargoDocChangeHandler();pm.changeDispatchingPlace()"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfLoading') }}</span>
              <div style="display: flex; justify-content: space-between">
                <cargo-advance-select
                  ref="loadingPortCode"
                  no="loadingPortCode"
                  :disabled="!lclslaveEnabled"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="form.loadingPortCode"
                  tag-name="englishName"
                  style="flex:1"
                  :class="importDifferenceField.loadingPortCode ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.loadingPortCodeChange(p);pm.cargoDocChangeHandler();pm.changeLoadingPort();pm.setPlannerChange()}"
                />&nbsp;
                <el-checkbox v-model="form.transfering" no="transfering" style="padding-left:2px;" @change="pm.updateSecondVesselInfo()">{{ $t('SeaExport.Transit') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item
              v-show="form.transfering"
              :label="$t('SeaExport.TransitPort')"
            >
              <cargo-advance-select
                no="transferPortCode"
                :disabled="!lclslaveEnabled"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.transferPortCode"
                @parentCallBack="p=>{form.transferPortCode=p.value;pm.updateSecondVesselInfo()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDischarge') }}</span>
              <cargo-advance-select
                no="dischargingPortCode"
                :disabled="!lclslaveEnabled"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode"
                :class="importDifferenceField.dischargingPortCode ? 'red-border' : ''"
                @parentCallBack="p=>{pm.dischargingPortCodeChange(p.value,form.carrierId);pm.cargoDocChangeHandler();pm.changeDischargingPort()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PlaceOfDelivery') }}</span>
              <cargo-advance-select
                no="destinationPortCode"
                class="port-of-delivery-selector"
                popper-class="port-of-delivery-selector-popper"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode"
                :class="importDifferenceField.destinationPortCode ? 'red-border' : ''"
                @parentCallBack="p=>{pm.destinationPortCodeChange(p);pm.cargoDocChangeHandler();pm.changeDestinationPort()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_PlaceOfDeliveryRegion') }}</span>
              <cargo-advance-select
                no="placeOfDeliveryRegion"
                :select-type="selectTypeNames.basic_data_Region"
                filterable
                :default-value="form.placeOfDeliveryRegion"
                :class="importDifferenceField.placeOfDeliveryRegion ? 'red-border' : ''"
                @parentCallBack="p=>{form.placeOfDeliveryRegion=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.TransshipmentTransportationMethod') }}</span>
              <cargo-advance-select
                no="transportationMode"
                :static-options="transportationModeInfos"
                :filter-tag-names="['chineseName', 'englishName', 'code']"
                filterable
                :tag-name="'englishName'"
                :default-value="form.transshipmentTransportationModeCode"
                @parentCallBack="p=>{form.transshipmentTransportationModeCode=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Airline')">
              <el-input
                :value="pm.vesselLine"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FinalDestination')">
              <el-input
                v-model="form.destinationPlace"
                no="destinationPlace"
                :class="importDifferenceField.destinationPlace ? 'red-border' : ''"
                @change="pm.cargoDocChangeHandler();pm.changeDestinationPlace()"
              />
            </el-form-item>
            <!-- 船公司 -->
            <el-form-item :label="$t('SeaExport.ShippingCompany')">
              <cargo-company-select
                ref="shippingCompany"
                no="carrierId"
                :disabled="!carrierIdEnabled"
                :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                :default-value="form.carrierId||''"
                :class="importDifferenceField.carrierId ? 'red-border' : ''"
                @change="p=>{pm.carrierChangeHandler(form.dischargingPortCode, p.value)}"
              />
            </el-form-item>
            <el-form-item v-if="bookingAgentVisible" :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                v-if="!bookingAgentDataProviderChange"
                no="bookingAgent"
                :select-type="selectTypeNames.basic_data_Company"
                filterable
                :disabled="!bookingAgentEnabled"
                :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
                :default-value="form.bookingAgent||''"
                :class="importDifferenceField.bookingAgent ? 'red-border' : ''"
                @parentCallBack="p=>{pm.bookingAgentChangeHandler(p)}"
              />
              <cargo-advance-select
                v-if="bookingAgentDataProviderChange"
                no="bookingAgent"
                :cache="false"
                :select-type="selectTypeNames.basic_data_Company"
                :disabled="!bookingAgentEnabled"
                :default-value="form.bookingAgent||''"
                :static-options="pm.bookingAgentArray"
                :class="importDifferenceField.bookingAgent ? 'red-border' : ''"
                @parentCallBack="p=>{pm.bookingAgentChangeHandler()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CarrierAgent')">
              <cargo-company-select
                no="carrierAgentId"
                :disabled="!lclslaveEnabled"
                :method-params="{seaCmpAgent:true,companyLob:'seaExport',active:true}"
                :default-value="form.carrierAgentId||''"
                :class="importDifferenceField.carrierAgentId ? 'red-border' : ''"
                @change="p=>{form.carrierAgentId=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.TerminalCompany')">
              <cargo-company-select
                no="terminalCompany"
                :method-params="{terminalCompany:true,companyLob:'seaExport',active:true}"
                :default-value="form.terminalCompany||''"
                style="width: 100%"
                :class="importDifferenceField.terminalCompany ? 'red-border' : ''"
                @change="p=>{JobUtils.terminalCompanyChangeHandler(form, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <el-select
                v-model="form.cargoSource"
                no="cargoSource"
                :disabled="!cargoSourceEnabled"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
                :class="importDifferenceField.cargoSource ? 'red-border' : ''"
                @change="form.designationAgent=0;pm.cargoSourceChange({fieldName:'cargoSource'})"
              >
                <el-option
                  v-for="(item,index) in CARGO_SOURCES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                ref="customJobType"
                no="customJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                :clearable="true"
                filterable
                :default-value="form.customJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="customJobTypeList"
                :method-params="{type:form.lob}"
                :class="importDifferenceField.customJobType ? 'red-border' : ''"
                @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
              />
            </el-form-item>
            <el-form-item v-if="form.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="form.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
              <cargo-company-select
                :method-params="{localAgent:true,active: true}"
                no="loadingAgentId"
                :disabled="readonly"
                :default-value="form.loadingAgentId||''"
                :data-filter-function="JobUtils.loadingAgentIdFilter"
                :tag-name="isZh ? 'chineseName' : 'englishName'"
                @change="p=>{form.loadingAgentId = p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.destinationAgent')">
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageC"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <img
                    :class="form.destinationAgent&&readonly?'':'not-click'"
                    :src="sopPic"
                    width="18"
                    height="28"
                    class="sop-img"
                    style="padding: 5px 0;cursor: pointer"
                    @click="pm.sopChangeHandler()"
                  >
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageC"
                  :content="warningImageCTip"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-advance-select
                  no="destinationAgent"
                  :select-type="selectTypeNames.basic_data_Company"
                  :disabled="!lclslaveEnabled"
                  :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
                  :default-value="form.destinationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  :class="importDifferenceField.destinationAgent ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
                />
                <cargo-advance-select
                  v-if="overseaAgentDataProviderChange"
                  no="destinationAgent2"
                  :select-type="selectTypeNames.basic_data_Company"
                  :cache="false"
                  :disabled="!lclslaveEnabled"
                  :default-value="form.destinationAgent||''"
                  filterable
                  :check-credit="true"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  :static-options="pm.destinationAgentArray"
                  @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item v-show="form.cargoSource==='NC'">
              <span slot="label" class="blue">{{ $t('SeaExport.NominatedAgent') }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageA"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <div>
                    <img
                      :class="form.designationAgent&&readonly?'':'not-click'"
                      :src="sopPic"
                      width="18"
                      height="28"
                      class="sop-img"
                      style="padding: 5px 0;cursor: pointer"
                      @click="pm.sopChangeBookingAgentHandler()"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageA"
                  :content="warningImageATip"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-advance-select
                  no="designationAgent"
                  class="designation-agent-selector"
                  popper-class="designation-agent-selector-popper"
                  :select-type="selectTypeNames.basic_data_Company"
                  :disabled="!designationAgentEnabled"
                  :method-params="{designationAgent:true,active:true}"
                  :check-credit="true"
                  :default-value="form.designationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
                />
                <cargo-advance-select
                  v-if="overseaAgentDataProviderChange"
                  no="designationAgent2"
                  :select-type="selectTypeNames.basic_data_Company"
                  :cache="false"
                  :disabled="!designationAgentEnabled"
                  :check-credit="true"
                  :default-value="form.designationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  :static-options="pm.designationAgentArray"
                  @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-company-select
                no="exChangeAgent"
                :disabled="!form.destinationPortService"
                :method-params="{bookingAgent:true,active:true}"
                :default-value="form.exChangeAgent||''"
                @change="onExChangeAgentChange"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="form.transportSource"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="form.statisticArea"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.statisticArea=item.value"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column" style="width: 400px;">
          <el-form
            :disabled="readonly"
            label-width="135px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.AdditionalInformation') }}</span>
            <!--关单信息-->
            <customs-declaration
              v-if="slaveCustomsDeclarationEnable"
              ref="customsDeclaration"
              no="customsDeclaration"
              :job="form"
              :is-editing="!readonly"
              :del-po-items-uuids="delPoItemsUuids"
              @quantityActualChange="quantityActualChange"
              @weightActualChange="weightActualChange"
              @cubageActualChange="cubageActualChange"
            />
            <el-form-item :label="$t('SeaExport.LocalService')">
              <el-checkbox
                v-model="form.warehousing"
                no="warehousing"
                style="display: block;"
                @change="pm.loadingTermChange('warehousing')"
              >{{ $t('SeaExport.WarehouseLoadingStorage') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.landTransportation"
                no="landTransportation"
                style="display: block;"
                @change="pm.loadingTermChange('landTransportation')"
              >{{ $t('SeaExport.DoorLoadingDelivery') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.selfDeliver"
                no="selfDeliver"
                style="display: block;"
              >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}
              </el-checkbox>
              <el-checkbox v-model="form.backUpWarehouse" no="backUpWarehouse" style="display: block;" @change="pm.backUpWarehouseChange()">{{ $t('SeaExport.BackUpWarehouse') }} </el-checkbox>
              <el-checkbox v-model="form.otherService" no="otherService" @change="pm.otherServiceChange()">{{ $t('SeaExport.Other') }} </el-checkbox>
              <el-input v-show="form.otherService" v-model="form.otherRemark" :class="importDifferenceField.otherRemark ? 'red-border' : ''" no="otherRemark" maxlength="10" />
            </el-form-item>
            <el-form-item v-if="!isFba && isBookingNew && form.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
              <el-checkbox
                v-model="form.dischargingPortDoor"
                no="dischargingPortDoor"
                style="display: block;"
              >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.usCustomsClearance"
                no="usCustomsClearance"
                style="display: block;"
              >{{ $t('queryJob.UsCustomsClearance') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.destPortCustomsClearance"
                no="destPortCustomsClearance"
                style="display: block;"
              >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item v-if="isFba && isBookingNew && form.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
              <el-checkbox-group v-model="selectedPodAddedService" @change="addedServiceChangeHandler">
                <el-checkbox
                  v-for="item in podAddedService"
                  :key="item.code"
                  :label="item.code"
                  style="display:block"
                  @change="val => singleAddedServiceChangeHandler(val, item)"
                >
                  {{ item.chineseName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item v-if="!jingyuWarehouse" :class="warehouseNoRed?'warehouseClass':''" :label="$t('SeaExport.WarehouseNo')">
              <el-input
                v-model="form.warehouseNo"
                no="warehouseNo"
                style="margin-bottom: 10px;"
                :disabled="!pm.warehouseNoeditable || readonly"
              />
              <el-button
                :disabled="!(isEdit && isHbl)"
                no="ObtainTheWarehouseNo"
                type="primary"
                style="padding-left:13px;padding-right:13px;"
                @click="pm.clickWarehouseNoHandler()"
              >{{ $t('SeaExport.ObtainTheWarehouseNo') }}
              </el-button>
              <!--此功能屏蔽-->
              <!--<cargo-button-container :disabled="form.jobState!==0" @click="pm.autoAllocateExternalHandler()">
                <el-button
                  type="primary"
                  style="padding-left:13px;padding-right:13px;"
                >{{ $t('SeaExport.AutoDistribution') }}</el-button>
              </cargo-button-container>-->
            </el-form-item>
            <el-form-item v-if="jingyuWarehouse" :class="warehouseNoRed?'warehouseClass':''" :label="$t('SeaExport.WarehouseNo')">
              <warehouse-no-input
                v-model="form.warehouseNo"
                :job-warehouse-nos.sync="jobWarehouseNos"
                :job="form"
                no="warehouseNo2"
                style="margin-bottom: 10px;"
                :disabled="!pm.warehouseNoeditable || readonly"
              />
            </el-form-item>
            <el-form-item
              :label="$t('Warehouse.WarehouseInState')"
              no="WarehouseState"
            >
              <el-select
                v-model="form.warehouseStatus"
                :disabled="true"
                :placeholder="$t('Message.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in WarehouseInState.WAREHOUSE_STATE"
                  :key="index"
                  :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBusinessNo')">
              <el-input
                :disabled="true"
                :value="form.lclMaster?form.lclMaster.jobNo:''"
              />
            </el-form-item>
            <el-form-item
              id="customerRefNo"
              :label="$t('SeaExport.BusinessReferenceNo')"
              :class="customerRefNoRed?'warehouseClass':''"
            >
              <el-tooltip
                :disabled="!customerRefNoTip"
                :content="customerRefNoTip"
                placement="right-end"
              >
                <el-input
                  v-model="form.customerRefNo"
                  no="customerRefNo"
                  :class="customerRefNoTip?'red':''"
                  @blur="pm.customerRefNoFocusOutHandler()"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="form.cargoSource === 'NC'" id="agentRefNo" :label="$t('SeaExport.NCReferenceNo')">
              <el-input v-model="form.agentRefNo" no="agentRefNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'warehouseClass':''">
              <el-input
                v-if="!openProjectConfig"
                v-model="form.poNo"
                no="poNo"
              />
              <cargo-project-select
                v-if="openProjectConfig"
                no="poNo"
                :default-value="form.poNo"
                :customer-id="form.customerId"
                :is-linked="isProjectLinkedCustomer"
                @change="p=>{form.poNo=p.value;form.projectName=p.projectName;changeProject()}"
              />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectName')"
            >
              <el-input v-model="form.projectName" :disabled="true" />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectBatch')"
            >
              <el-input v-model="form.projectBatch" no="projectBatch" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                no="customsBroker"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_Company"
                :data-filter-function="customsBrokerFilter"
                filterable
                :default-value="form.customsBroker||''"
                :placeholder="!customsBrokerEnabled? $t('SeaExport.PleaseTickCustomsDeclarationOption'):$t('CargoMsg.Cargo_keyWordsTip')"
                :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
                @parentCallBack="p=>{pm.customsBrokerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="!isFba" :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethod"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:2}"
                tag-value="serialNum"
                filterable
                :default-value="form.customClaim"
                @parentCallBack="p=>{form.customClaim=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{form.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="tradeTerm"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                filterable
                :default-value="form.tradeTerm"
                @parentCallBack="p=>{form.tradeTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HaulageCompany')">
              <cargo-company-select
                no="carryingCmp"
                :disabled="!form.landTransportation"
                :method-params="{truckCmp:true,active:true}"
                :default-value="form.carryingCmp||''"
                :placeholder="!form.landTransportation?$t('SeaExport.PleaseTickDoorLoadingDeliveryOption'):$t('CargoMsg.Cargo_keyWordsTip')"
                @change="p=>{pm.carryingCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="isFba ? $t('SeaExport.DomesticWarehouse') : (openWarehouse ? $t('SeaExport.WarehouseSupplier') : $t('SeaExport.Warehouse'))">
              <cargo-company-select
                no="warehouseCmp"
                :disabled="!warehouseEabled"
                :method-params="{warehouse:true,active:true}"
                :default-value="isFba ? Number(fbaJob.domesticWarehouse)||'' : form.warehouseCmp||''"
                :placeholder="!warehouseEabled? $t('SeaExport.PleaseSelectWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
                @change="p=>{pm.warehouseCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="openWarehouse" :label="$t('SeaExport.WareHouseName')">
              <el-select
                ref="warehouseName"
                v-model="form.warehouseName"
                no="warehouseName"
                :disabled="!warehouseEabled||!form.warehouseCmp"
                :allow-create="true"
                filterable
                :clearable="true"
                @change="warehouseNameChangeHandler"
              >
                <el-option
                  v-for="(item,index) in warehouseNameList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseName"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BackUpWarehouse')">
              <cargo-advance-select
                no="backUpWarehouseCmp"
                :select-type="selectTypeNames.basic_data_Company"
                :cache="false"
                :disabled="!backUpWarehouseEnabled"
                :default-value="form.backUpWarehouseCmp||''"
                filterable
                :static-options="backUpWarehouseCompanyList"
                :placeholder="!backUpWarehouseEnabled? $t('SeaExport.PleaseSelectBackUpWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{pm.backUpWarehouseCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.ForeignWarehouse')">
              <cargo-advance-select
                no="overseaWarehouseCode"
                :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                filterable
                :method-params="{ifFba:false}"
                :clearable="false"
                tag-name="countryChineseName"
                tag-value="warehouseCode"
                :default-value="form.overseaWarehouseCode"
                style="width:100%;"
                @parentCallBack="p=>{form.overseaWarehouseCode=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MBLTransportationClause')">
              <cargo-advance-select
                no="freightTerm"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                :clearable="false"
                :default-value="form.freightTerm"
                :class="importDifferenceField.freightTerm ? 'red-border' : ''"
                @parentCallBack="p=>{form.freightTerm=p.value}"
              />
            </el-form-item>
            <el-form-item
              v-show="!form.mblOnly"
              :label="$t('SeaExport.HBLTransportationClause')"
            >
              <cargo-advance-select
                no="freightTermHBL"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                :clearable="false"
                :default-value="form.freightTermHBL"
                :class="importDifferenceField.freightTermHBL ? 'red-border' : ''"
                @parentCallBack="p=>{form.freightTermHBL=p.value;pm.freightTermHBLChange()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="paymentTermMBL"
                :disabled="!lclslaveEnabled"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :clearable="false"
                :default-value="form.paymentTermMBL"
                :class="importDifferenceField.paymentTermMBL ? 'red-border' : ''"
                @parentCallBack="p=>{form.paymentTermMBL=p.value;pm.paymentTermMBLChange()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfMblPayment')">
              <el-input
                v-show="!pm.isShowAcPaymentPlaceBL"
                v-model="mblDoc.paymentPlaceBL"
                no="paymentPlaceBL"
                :disabled="!(isEdit && (form.paymentTermMBL==='3P' || form.paymentTermMBL==='PP'))"
                @change="pm.fieldChangeHandler()"
              />
              <cargo-advance-select
                v-if="pm.isShowAcPaymentPlaceBL"
                no="paymentPlaceBL"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="mblDoc.paymentPlaceBL||''"
                @parentCallBack="p=>{mblDoc.paymentPlaceBL = p.value}"
              />
            </el-form-item>
            <el-form-item
              v-show="!form.mblOnly"
              :label="$t('SeaExport.HBLFreightClause')"
            >
              <cargo-advance-select
                no="paymentTermHBL"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :clearable="false"
                :default-value="form.paymentTermHBL"
                :allow-create="true"
                :class="importDifferenceField.paymentTermHBL ? 'red-border' : ''"
                @parentCallBack="p=>{pm.paymentSelectHblChange(p.value)}"
              />
            </el-form-item>
            <el-form-item
              v-show="!form.mblOnly"
              :label="$t('SeaExport.PlaceOfHblPayment')"
            >
              <el-input v-model="hdoc.paymentPlaceBL" no="paymentPlaceBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContractRateProperty')">
              <el-select
                v-model="form.bookingTerm"
                no="bookingTerm"
                :disabled="!pm.bookingTermEditable"
                :placeholder="!pm.bookingTermEditable ? '' : $t('SeaExport.PleaseSelect')"
                :clearable="false"
                size="mini"
                :class="importDifferenceField.bookingTerm ? 'red-border' : ''"
              >
                <el-option
                  v-for="(item,index) in bookingTerms"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                filterable
                :clearable="false"
                :default-value="form.incoTerm"
                :class="importDifferenceField.incoTerm ? 'red-border' : ''"
                @parentCallBack="p=>{form.incoTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoSize')">
              <el-input
                v-model="form.measurements"
                no="measurements"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CargoSize'),form.measurements,val=>{form.measurements=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SpecialPriceInstructions')">
              <el-input v-model="form.salePriceRemarks" no="salePriceRemarks" />
            </el-form-item>
            <div style="display: flex;justify-content: space-around">
              <el-checkbox
                v-model="form.mblOnly"
                no="mblOnly"
                style="margin: 0"
                @change="pm.isMblOnlyChange()"
              >{{ $t('SeaExport.DirectBusiness') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.transfering"
                no="transfering"
                :disabled="!lclslaveEnabled"
                style="margin: 0"
              >{{ $t('SeaExport.Transport') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.batch"
                no="batch"
                :disabled="!lclslaveEnabled"
                style="margin: 0"
              >{{ $t('SeaExport.InBatches') }}
              </el-checkbox>
              <el-checkbox v-model="form.salePrice" no="salePrice" style="margin: 0">{{ $t('SeaExport.SpecialPrice') }}</el-checkbox>
              <el-checkbox
                v-model="form.allocation"
                no="allocation"
                style="margin: 0"
              >{{ 'Alloc' }}
              </el-checkbox>
              <el-checkbox
                v-model="form.availableCabinSpace"
                no="availableCabinSpace"
              >{{ $t('CargoMsg.Cargo_AvailableCabinSpace') }}
              </el-checkbox>
            </div>
            <!-- 隐藏免柜租期 免堆天数 关区申请 代码撤回-->
            <el-form-item :label="$t('SeaExport.FreeDemurrage')">
              <el-input-number v-model="form.freeDemurrage" :controls="false" style="width: 100%;" no="freeDemurrage" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreeDetention')">
              <el-input-number v-model="form.freeDetention" :controls="false" style="width: 100%;" no="freeDetention" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsAreaApplication')">
              <el-input v-model="form.customsAreaApplication" no="customsAreaApplication" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BoxOneWay')">
              <el-select v-model="form.boxOneWay" no="boxOneWay">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" :value="0" />
                <el-option :label="$t('CargoMsg.Cargo_OneWay')" :value="1" />
                <el-option :label="$t('CargoMsg.Cargo_Circulation')" :value="2" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column" :style="$selectByLang('width: 330px', 'width: 330px', 'width: 340px')">
          <el-form
            :disabled="readonly"
            :label-width="$selectByLang('120px', '120px', '130px')"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.ContainerInfo2') }}</span>
            <booking-sea-eq-data-grid
              v-if="form.containerLoadType==='FCL'||form.containerLoadType==='BB'||form.containerLoadType==='BCF'"
              ref="bookingSeaEqDataGrid"
              no="bookingSeaEqDataGrid"
              :value="seaEqList"
              :container-load-type="form.containerLoadType"
              :is-edit="isEdit"
              :job="form"
              :slave-customs-declaration-enable="slaveCustomsDeclarationEnable"
              @eqQuantityChange="eqQuantityChangeHandler"
            />
            <booking-bulk-data-grid
              v-if="form.containerLoadType==='BULK'"
              no="BULK"
              :value="cargoBulkDetailList"
              :context="context"
              :job-uuid="form.uuid"
              :is-edit="isEdit"
            />
            <booking-special-data-grid
              v-if="form.containerLoadType==='SPA'"
              no="SPA"
              :value="seaEqList"
              :is-edit="isEdit"
              :job="form"
              @eqQuantityChange="eqQuantityChangeHandler"
            />
            <div v-if="showCharacteristic" style="display: flex;justify-content: space-around">
              <el-checkbox
                v-model="form.electric"
                no="electric"
                style="margin: 0"
              >{{ $t('CargoMsg.Electric') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.magnetic"
                no="magnetic"
                style="margin: 0"
              >{{ $t('CargoMsg.Magnetic') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.powder"
                no="powder"
                style="margin: 0"
              >{{ $t('CargoMsg.Powder') }}
              </el-checkbox>
              <el-checkbox v-model="form.liquid" no="liquid">{{ $t('CargoMsg.Liquid') }}</el-checkbox>
            </div>

            <el-form-item
              :label="$t('SeaExport.QuantityConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.quantityContract"
                  no="quantityContract"
                  :precision="0"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  :class="importDifferenceField.quantityContract ? 'red-border' : ''"
                  @change="pm.jobContractQwcChange(1);calcEstVolumetricAndChargeWeight()"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="quantityActual"
                  v-model="form.quantityActual"
                  no="quantityActual"
                  :precision="0"
                  :disabled="pm.billChargeFlag || !isJydEditJobFields"
                  :min="0"
                  :class="importDifferenceField.quantityActual ? 'red-border' : ''"
                  @change="quantityActualChange();pm.syncQwcToPoItems(form.quantityActual || 0, null, null)"
                />
                <span>PCS</span>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.WeightConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.weightContract"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  :class="importDifferenceField.weightContract ? 'red-border' : ''"
                  @change="weightContractChange();calcEstVolumetricAndChargeWeight()"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="weightActual"
                  v-model="form.weightActual"
                  no="weightActual"
                  :precision="3"
                  :disabled="pm.billChargeFlag || !isJydEditJobFields"
                  :min="0"
                  :class="importDifferenceField.weightActual ? 'red-border' : ''"
                  @change="weightActualChange();pm.syncQwcToPoItems(null, form.weightActual || 0, null)"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.CubageConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.cubageContract"
                  no="cubageContract"
                  :precision="3"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  :class="importDifferenceField.cubageContract ? 'red-border' : ''"
                  @change="cubageContractChange();calcEstVolumetricAndChargeWeight()"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="cubageActual"
                  v-model="form.cubageActual"
                  no="cubageActual"
                  :precision="3"
                  :disabled="!cubageActualEnabled || !isJydEditJobFields"
                  :min="0"
                  :class="importDifferenceField.cubageActual ? 'red-border' : ''"
                  @change="cubageActualChange();pm.syncQwcToPoItems(null, null, form.cubageActual || 0)"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item
              v-if="isFba"
              :label="$t('SeaExport.VolumetricWeightConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.volumetricWeightContract"
                  no="volumetricWeightContract"
                  :precision="3"
                  :min="0"
                  @change="calcEstVolumetricAndChargeWeight(form.volumetricWeightContract)"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="volumetricWeight"
                  v-model="form.volumetricWeight"
                  no="volumetricWeight"
                  :precision="3"
                  :min="0"
                  @change="changeVolumetricWeight"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item
              v-if="isFba"
              :label="$t('SeaExport.ChargeWeightConsignActual')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.chargeWeightContract"
                  no="chargeWeightContract"
                  :precision="3"
                  :min="0"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="chargeWeight"
                  v-model="form.chargeWeight"
                  no="chargeWeight"
                  :precision="3"
                  :min="0"
                  @change="changeChargeWeight"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item v-if="isFba" label-width="0">
              <div style="display: flex;justify-content: space-around">
                <el-checkbox v-model="fbaJob.electric" style="margin-right: 10px;margin-left: 20px;">{{ $t('SeaExport.WithElectricity') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.magnetic" style="margin-right: 10px;">{{ $t('SeaExport.WithMagnetism') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.powdery" style="margin-right: 10px;">{{ $t('SeaExport.Powder') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.liquid" style="margin-right: 10px;">{{ $t('SeaExport.Liquid') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item
              v-show="form.containerLoadType==='BULK'"
              :label="$t('SeaExport.QuantitySize')"
            >
              <auto-number-input
                v-model="form.insideQuantitySize"
                no="insideQuantitySize"
                :precision="0"
                style="width:100%;"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Package')"
            >
              <cargo-packing-select
                no="packing"
                :default-value="form.packing"
                :class="importDifferenceField.packing ? 'red-border' : ''"
                @change="p=>{form.packing=p.value;pm.txtPackingChangeHandler()}"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Pieces')"
            >
              <auto-number-input
                v-model="form.insideQuantity"
                no="insideQuantity"
                :precision="0"
                :min="0"
                :class="importDifferenceField.insideQuantity ? 'red-border' : ''"
                @valCallBack="(val)=>{
                  form.insideQuantity = val
                }"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.PiecesType')"
            >
              <cargo-packing-select
                no="insidePacking"
                :default-value="form.insidePacking"
                @change="p=>{form.insidePacking=p.value}"
              />
            </el-form-item>
            <el-form-item
              v-if="!isFba"
              :label="$t('SeaExport.ChargedWeightRT')"
            >
              <div style="display: flex">
                <auto-number-input
                  v-model="form.chargeWeight"
                  no="chargeWeight"
                  :precision="3"
                  style="flex:1"
                  :disabled="!chargeWeightEnabled"
                  :min="0"
                  :class="importDifferenceField.chargeWeight ? 'red-border' : ''"
                  @change="pm.chargeWeightChange();"
                />
                <span>M/T</span>
              </div>
            </el-form-item>
            <el-form-item v-show="isEdit">
              <div slot="label">
                <el-button
                  no="Copy2"
                  type="primary"
                  @click="transcribeDialog.visible=true"
                >{{ $t('SeaExport.Copy2') }}
                </el-button>
              </div>
            </el-form-item>
          </el-form>
          <!--集翊达-->
          <el-form
            v-if="toExoSystemJYD"
            :disabled="lockJobByPrintHblZb ? false : readonly"
            :label-width="$selectByLang('120px', '120px', '130px')"
            label-position="right"
          >
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="form.remarks"
                no="remarks"
                type="textarea"
                :rows="4"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.remarks,val=>{form.remarks=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationRequirements')">
              <el-tooltip
                :content="form.operationContent"
                placement="left"
              >
                <div
                  slot="content"
                  v-html="form.operationContent ? form.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')"
                />
                <el-input
                  no="operationContent"
                  :value="form.operationContent"
                  :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
                  type="textarea"
                  :rows="4"
                  @dblclick.native="selectOperationReqDialog.value=form.operationContent;selectOperationReqDialog.visible=isEdit||lockJobByPrintHblZb"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationTips')">
              <el-input
                v-model="form.operationTips"
                no="operationTips"
                type="textarea"
                :rows="4"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.OperationTips'),form.operationTips,val=>{form.operationTips=val})"
              />
            </el-form-item>
          </el-form>
          <el-form
            :disabled="readonly"
            :label-width="$selectByLang('120px', '120px', '130px')"
            label-position="right"
          >
            <el-form-item
              :label="$t('SeaExport.EnglishDescriptionOfGoods')"
            >
              <special-character-tip :texts="specialCharCheck.cargoEnglishName">
                <cargo-rich-textarea
                  ref="cargoTextarea1"
                  v-model="form.cargoEnglishName"
                  no="cargoEnglishName"
                  :show-count="true"
                  :text-chars="0"
                  :warning-count="-1"
                  :disabled="!isEdit"
                  wrap-symbol="r"
                  auto-half-word
                  :auto-uppercase="isUppercaseByConfig"
                  style="height: 110px"
                  :class="(importDifferenceField.cargoEnglishName || form.cargoEnglishNameWarning === 1) ? 'red-border' : ''"
                  @change="onCargoEnglishNameChange"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{pm.cargoEnglishNameChangeHandler(val)},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Marks')"
            >
              <special-character-tip :texts="specialCharCheck.mark">
                <cargo-rich-textarea
                  ref="cargoTextarea2"
                  v-model="form.mark"
                  no="mark"
                  :show-count="true"
                  :text-chars="0"
                  :warning-count="-1"
                  wrap-symbol="r"
                  auto-half-word
                  :auto-uppercase="isUppercaseByConfig"
                  :disabled="!isEdit"
                  style="height: 110px"
                  :class="importDifferenceField.mark ? 'red-border' : ''"
                  @change="onMarkChange"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{pm.markChangeHandler(val)},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig})"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.HsCode') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  no="Search"
                  type="primary"
                  @click="showHsCodeSearchDialog($t('Message.SelectHsCode'),val=>{pm.hsCodeChangeHandler(val.code)})"
                >{{ $t('SeaExport.Search') }}
                </el-button>
              </div>
              <el-input
                v-model="form.hsCode"
                no="hsCode"
                type="textarea"
                :rows="5"
                :class="importDifferenceField.hsCode ? 'red-border' : ''"
                @change="val=>{pm.hsCodeChangeHandler(val)}"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{pm.hsCodeChangeHandler(val)})"
              />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.ChineseDescriptionOfGoods') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  no="ChineseDescriptionOfGoods"
                  type="primary"
                  @click="showHsCodeSearchDialog($t('Message.SelectCargoChineseName'),p=>form.cargoChineseName=p.commodityName)"
                >{{ $t('SeaExport.Search') }}
                </el-button>
              </div>
              <cargo-rich-textarea
                v-model="form.cargoChineseName"
                no="cargoChineseName"
                :disabled="!isEdit"
                :auto-uppercase="false"
                :auto-half-word="false"
                wrap-symbol="r"
                :class="(importDifferenceField.cargoEnglishName || form.cargoChineseNameWarning === 1) ? 'red-border' : ''"
                style="height: 110px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,val=>{form.cargoChineseName=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CategoryOfGoods')" class="custom">
              <cargo-advance-select
                no="cargoCode"
                :select-type="selectTypeNames.basic_data_CargoInformation"
                :disabled="readonly || canEditInternalDelegatedJobField"
                filterable
                :clearable="true"
                :default-value="form.cargoCode"
                :allow-create="false"
                :class="importDifferenceField.cargoCode ? 'red-border' : ''"
                @parentCallBack="p=>{pm.cargoCodeChange(p.value)}"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="form.cargoName"
                no="cargoName"
                :class="importDifferenceField.cargoName ? 'red-border' : ''"
                :disabled="!(isEdit && form.cargoCode) || canEditInternalDelegatedJobField"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="108px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.OperationInfo') }}</span>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.SalesCompany') }}</span>
              <el-input
                :value="txtSalesOffice"
                :disabled="true"
                :class="importDifferenceField.salesOffice ? 'red-border' : ''"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.Sales') }}</span>
              <div style="display: flex;justify-content: space-between">
                <cargo-user-select
                  ref="sales"
                  no="sales"
                  :disabled="!saleEnabled"
                  :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                  :default-value="form.sales||''"
                  :static-options="salesList"
                  :placeholder="salesPrompt"
                  :merge-load="true"
                  style="flex: 1"
                  :class="importDifferenceField.sales ? 'red-border' : ''"
                  @change="p=>{form.salesRecord = p.value;pm.salesChangeHandler(p);}"
                />&nbsp;
                <el-checkbox
                  v-model="form.provisioned"
                  no="provisioned"
                  style="margin-left: 5px"
                  :disabled="true"
                >{{ $t('SeaExport.Accrued') }}
                </el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="form.cargoSalesId||''"
                :merge-load="true"
                :static-options="cargoSalesList"
                :class="importDifferenceField.cargoSalesId ? 'red-border' : ''"
                @change="p=>{form.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.SalesDepartment') }}</span>
              <cargo-department-new-select
                no="salesOffice"
                :disabled="!form.sales"
                :sales-id="Number(form.sales)"
                :office-id="form.salesOffice"
                :enables="true"
                :department-id="Number(form.salesDepartment)"
                :class="importDifferenceField.salesDepartment ? 'red-border' : ''"
                @change="p=>{form.salesDepartment=p.value;pm.departmentChargeHandler()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-office-select
                no="opOffice"
                :disabled="(!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
                :is-regional-commission="isRegionalCommission"
                :office-id="Number(form.opOffice)"
                :class="importDifferenceField.opOffice ? 'red-border' : ''"
                @change="p=>{form.opOffice=p.value;form.opDepartment=0;pm.opOfficeChangeHandler();contractRuleFieldChange(form.customerId, form.designationAgent)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
              <cargo-department-select
                no="opDepartment"
                :disabled="pm.isWithinCloseAccountDate"
                :office-id="Number(form.opOffice)"
                :enables="true"
                :department-id="Number(form.opDepartment)"
                :class="importDifferenceField.opDepartment ? 'red-border' : ''"
                @change="p=>{form.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select
                ref="op"
                no="op"
                :disabled="!opEabled"
                :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
                :default-value="form.op||''"
                :merge-load="true"
                :static-options="userPortRoleData.op"
                :class="importDifferenceField.op ? 'red-border' : ''"
                @change="p=>{form.op=p.value;pm.txtOPChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(form.csrOffice)"
                :class="importDifferenceField.csrOffice ? 'red-border' : ''"
                @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(form.csrOffice)"
                :enables="true"
                :department-id="Number(form.csrDepartment)"
                :class="importDifferenceField.csrDepartment ? 'red-border' : ''"
                @change="p=>{form.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                ref="csr"
                no="csr"
                :method-params="{officeId:pm.isEntrustOrder||form.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
                :default-value="form.csr||''"
                :merge-load="true"
                :static-options="userPortRoleData.csr"
                :class="importDifferenceField.csr ? 'red-border' : ''"
                @change="p=>{pm.csrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
                :default-value="form.siteOP||''"
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                :default-value="form.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                @change="p=>{form.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(form.dcOffice)"
                :class="importDifferenceField.dcOffice ? 'red-border' : ''"
                @change="p=>{form.dcOffice=p.value;form.dcDepartment=0/* ;pm.dcOfficeChangeHandler() */}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(form.dcOffice)"
                :enables="true"
                :department-id="Number(form.dcDepartment)"
                :class="importDifferenceField.dcDepartment ? 'red-border' : ''"
                @change="p=>{form.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                ref="dc"
                no="dc"
                :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
                :default-value="form.dc||''"
                :merge-load="true"
                :static-options="userPortRoleData.doc"
                :class="importDifferenceField.dc ? 'red-border' : ''"
                @change="p=>{pm.dcChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(form.plannerOffice)"
                :class="importDifferenceField.plannerOffice ? 'red-border' : ''"
                @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(form.plannerOffice)"
                :enables="true"
                :department-id="Number(form.plannerDepartment)"
                :class="importDifferenceField.plannerDepartment ? 'red-border' : ''"
                @change="p=>{form.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlinePerson2')">
              <cargo-user-select
                no="planner"
                :method-params="{officeId:form.opOffice,category:'role',shape:'seaLine'}"
                :default-value="form.planner||''"
                :merge-load="true"
                :static-options="userPortRoleData.seaLine"
                :class="importDifferenceField.planner ? 'red-border' : ''"
                @change="p=>{form.planner=p.value;pm.txtPlannerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="form.userDefinedRoleId1||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole1"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="form.userDefinedRoleId2||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole2"
                @change="p=>{pm.userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
            <div v-if="this.$store.getters.tenantId === 889">
              <micro-app
                name="child-user-defined-role"
                :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
                router-mode="pure"
                destroy
                @datachange="userDefinedRoleDataChange"
              />
            </div>
            <special-requests-grid
              ref="selectedSpecialRequest"
              v-model="form.satisfiedRequests"
              no="satisfiedRequests"
              :is-edit="isEdit"
              :customer-id="Number(form.customerId)"
              :lob="form.lob"
              :job="form"
              style="margin-bottom: 5px"
            />
          </el-form>
          <el-form
            v-if="!toExoSystemJYD"
            :disabled="lockJobByPrintHblZb ? false : readonly"
            label-width="108px"
            label-position="right"
          >
            <el-form-item :label="$t('SeaExport.OperationRequirements')">
              <el-tooltip
                :content="form.operationContent"
                placement="left"
              >
                <div
                  slot="content"
                  v-html="form.operationContent ? form.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')"
                />
                <el-input
                  no="operationContent"
                  :value="form.operationContent"
                  :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
                  type="textarea"
                  :rows="4"
                  @dblclick.native="selectOperationReqDialog.value=form.operationContent;selectOperationReqDialog.visible=isEdit||lockJobByPrintHblZb"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationTips')">
              <el-input
                v-model="form.operationTips"
                no="operationTips"
                type="textarea"
                :rows="4"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.OperationTips'),form.operationTips,val=>{form.operationTips=val})"
              />
            </el-form-item>
          </el-form>
          <el-form
            :disabled="readonly"
            label-width="108px"
            label-position="right"
          >
            <el-form-item :label="$t('SeaExport.ExtraChargeClause')">
              <el-input
                no="txtSurchargeTerms"
                :value="txtSurchargeTerms"
                :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddExtraChargeClause')"
                type="textarea"
                :rows="4"
                @dblclick.native="selectSurchargeTermsDialog.rowData=form.surchargeTerms;selectSurchargeTermsDialog.visible=true"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehousingInfo')">
              <el-input
                no="txtWhs"
                :disabled="true"
                type="textarea"
                :rows="4"
                :value="txtWhs"
              />
            </el-form-item>
          </el-form>
          <el-form
            v-if="!toExoSystemJYD"
            :disabled="lockJobByPrintHblZb ? false : readonly"
            label-width="108px"
            label-position="right"
          >
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="form.remarks"
                no="remarks"
                type="textarea"
                :rows="4"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.remarks,val=>{form.remarks=val})"
              />
            </el-form-item>
          </el-form>
        </div>
        <!-- FBA相关信息-->
        <div v-if="isFba" class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="120px"
            label-position="right"
          >
            <span class="title">{{ 'FBA' }}</span>
            <el-form-item v-if="!isEdit" :label="$t('SeaExport.ServiceChannel')">
              <cargo-advance-select
                no="serviceChannel"
                disabled
                :select-type="selectTypeNames.basic_data_FbaChannel"
                filterable
                :method-params="{shippingType: fbaJob.shippingType, active: true}"
                :clearable="true"
                :default-value="fbaJob.serviceChannel"
                @parentCallBack="p=>{fbaJob.serviceChannel=p.value;}"
              />
            </el-form-item>
            <el-form-item v-if="isEdit" :label="$t('SeaExport.ServiceChannel')">
              <el-select v-model="fbaJob.serviceChannel" filterable clearable @change="changeServiceChannel">
                <el-option
                  v-for="(item,index) in channel4JobSelect"
                  :key="index"
                  :label="item.channelName"
                  :value="item.channelName"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.EstimatedStorageReadyGoodsTime') }}</span>
              <el-date-picker
                v-model="fbaJob.preWarehousingTime"
                no="preWarehousingTime"
                type="datetime"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                @change="pm.preWarehousingChangeHandler()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ExpectedAmazonWarehouseEntryTime')">
              <el-date-picker
                v-model="fbaJob.preAmazonWhTime"
                no="preAmazonWhTime"
                :disabled="readonly"
                type="date"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Destination') }}</span>
              <div style="display: flex; flex: 1;">
                <el-tooltip :content="fbaJob.warehouseCode" placement="bottom-end">
                  <el-cascader
                    v-model="fbaJob.warehouseCode"
                    style="width: 91px; padding-right: 2px;"
                    :options="destinations"
                    filterable
                    :clearable="true"
                    @focus="JobUtils.focusWarehouseCode(fbaJob)"
                    @blur="JobUtils.blurWarehouseCode(fbaJob)"
                    @change="p=>{JobUtils.warehouseCodeHandler(fbaJob, p);changeWarehouseCode}"
                  />
                </el-tooltip>
                <el-checkbox v-model="fbaJob.remoteWarehouse" no="remoteWarehouse">{{ $t('SeaExport.RemoteWarehouse') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Warehouse.DestinationCountry')">
              <el-input v-model="fbaJob.country" :disabled="true" no="country" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ZIP')">
              <el-input v-model="fbaJob.zipCode" :disabled="true" no="zipCode" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DestinationDeliveryMethod')">
              <el-select v-model="fbaJob.destinationDistribution" no="destinationDistribution" filterable @change="destinationDistributionChange">
                <el-option
                  v-for="(item,index) in FbaJobConstants.ORDER_DESTINATION_DISTRIBUTION_TYPES"
                  :key="index"
                  :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('SeaExport.CourierCompany')">
              <el-select v-model="fbaJob.expressCompany" no="expressCompany" placeholder="" clearable>
                <el-option
                  v-for="item in FbaJobConstants.EXPRESS_COMPANYS"
                  :key="item.code"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('SeaExport.TrackingNumber')">
              <el-input v-model="fbaJob.expressNo" no="expressNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.POoriginalNumber')">
              <el-input v-model="fbaJob.poNumber" no="poNumber" />
            </el-form-item>
            <el-form-item :label="'Shipment Id'">
              <el-input v-model="fbaJob.shipmentId" no="shipmentId" />
            </el-form-item>
            <el-form-item :label="'Reference Id'">
              <el-input v-model="fbaJob.referenceId" no="referenceId" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaJob.ChargingMethod') }}</span>
              <el-radio-group v-model="fbaJob.chargingMethod" no="chargingMethod" @change="chargingMethodChange">
                <el-radio :label="'0'">{{ 'KG' }}</el-radio>
                <el-radio :label="'1'">{{ 'CBM' }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('FbaJob.BubbleCountingRatio')">
              <!--              <el-input-number v-model="fbaJob.bubbleCountingRatio" no="bubbleCountingRatio" controls-position="right" :max="999999" :min="0" style="width: 100%;" @change="bubbleCountingChange"/>-->
              <el-input v-model="fbaJob.bubbleCountingRatio" no="bubbleCountingRatio" style="width: 100%;" @change="bubbleCountingChange" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.pbProportion')">
              <div style="display: flex; flex: 1;">
                <!--                <el-input-number v-model="fbaJob.bubbleSplittingRatio" no="bubbleSplittingRatio" controls-position="right" :max="10" :min="0" :precision="0" />%-->
                <el-input v-model="fbaJob.bubbleSplittingRatio" no="bubbleSplittingRatio" @change="bubbleSplittingRatioChange" />%
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethodPol"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:0}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPol"
                @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ClearanceMethod')">
              <cargo-advance-select
                no="customsMethodPod"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:1}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPod"
                @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EORIEnterpriseNumber')">
              <el-input v-model="fbaJob.eoriNo" no="eoriNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VATTaxNumber')">
              <el-input v-model="fbaJob.vatNo" no="vatNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VATRegistrationCountry')">
              <cargo-advance-select
                no="taxRegisterCountry"
                :select-type="selectTypeNames.basic_data_Country"
                filterable
                :callback-params="{key:'taxRegisterCountry'}"
                callback-method-type="value"
                :default-value="fbaJob.taxRegisterCountry"
                @parentCallBack="p=>{fbaJob.taxRegisterCountry = p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VATRegistrationAddress')">
              <el-input v-model="fbaJob.taxRegisterAddress" no="taxRegisterAddress" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VATCompanyEnglishName')">
              <el-input v-model="fbaJob.taxCompany" no="taxCompany" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form
            :disabled="lockJobByPrintHblZb ? false : readonly"
            label-width="100px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.UserDefinedArea') }}</span>
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="form.userDefinedField1"
                no="userDefinedField1"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),form.userDefinedField1,val=>{form.userDefinedField1=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="form.userDefinedField2"
                no="userDefinedField2"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),form.userDefinedField2,val=>{form.userDefinedField2=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="form.userDefinedField3"
                no="userDefinedField3"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),form.userDefinedField3,val=>{form.userDefinedField3=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="form.userDefinedField4"
                no="userDefinedField4"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),form.userDefinedField4,val=>{form.userDefinedField4=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="form.taxNature"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div
        class="section"
        style="width:100%"
      >
        <span class="title">{{ $t('SeaExport.CustomerDeliveryInfo') }}</span>
        <div>
          <el-button v-if="!isFba" no="CodeSearching" :disabled="readonly" type="primary" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
          <el-button v-if="isFba" no="FbaCodeSearching" :disabled="readonly" type="primary" @click="fbaCodeSearchBtn">{{ $t('SeaExport.CodeSearching') }}</el-button>
        </div>
        <div class="form-row" style="display:flex;flex-direction:row;margin-top:8px">
          <el-form
            label-width="50px"
            label-position="left"
            style="position:relative;margin-right:10px"
          >
            <char-count :form="form" prefix="shipper" />
            <el-form-item
              :label="$t('SeaExport.Shipper')"
            >
              <cargo-input v-model="form.shipperCode" no="shipperCode" :class="importDifferenceField.shipperCode ? 'red-border' : ''" style="width:115px;margin-right: 5px" :placeholder="readonly ? '' : $t('SeaExport.ShipperId')" :auto-uppercase="notUppercaseShipperConsigneNotify" :disabled="readonly" />
              <cargo-company-select
                no="shipperId"
                :disabled="readonly"
                :method-params="{shipper:true,active:true}"
                :default-value="form.shipperId||''"
                style="display: inline-block;width:145px;"
                :class="importDifferenceField.shipperId ? 'red-border' : ''"
                @change="data => {pm.shipperChange(data)}"
              />
            </el-form-item>
            <el-form-item
              v-for="i in 7"
              :key="i"
              label-width="0"
            >
              <special-character-tip :texts="specialCharCheck['shipperLine'+i]">
                <cargo-input
                  :ref="'shipperLine'+i"
                  v-model="form['shipperLine'+i]"
                  :use-read-only="true"
                  :disabled="readonly"
                  :no="'shipperLine'+i"
                  :placeholder="placeholderSFT(i)"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :class="importDifferenceField['shipperLine'+i] ? 'red-border' : ''"
                  @change="()=>wrapAddr(form,'shipperLine'+i,i+1 > 6 ? null :'shipperLine'+(i+1),200)"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,notUppercaseShipperConsigneNotify,{autoHalfWord:true,autoUppercase:notUppercaseShipperConsigneNotify})"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
          <el-form
            label-width="65px"
            label-position="left"
            style="position:relative;margin-right:20px"
          >
            <char-count :form="form" prefix="consignee" />
            <el-form-item
              :label="$t('SeaExport.Consignee')"
            >
              <cargo-input v-model="form.consigneeCode" no="consigneeCode" :class="importDifferenceField.consigneeCode ? 'red-border' : ''" style="width:115px;margin-right: 5px" :placeholder="readonly ? '' : $t('SeaExport.ConsigneeId')" :auto-uppercase="notUppercaseShipperConsigneNotify" :disabled="readonly" />
              <cargo-company-select
                no="consigneeId"
                :disabled="readonly"
                :method-params="{consignee:true,active:true}"
                :default-value="form.consigneeId||''"
                style="display: inline-block;width:145px;"
                :class="importDifferenceField.consigneeId ? 'red-border' : ''"
                @change="data => {pm.consigneeChange(data)}"
              />
            </el-form-item>
            <el-form-item
              v-for="i in 7"
              :key="i"
              label-width="0"
            >
              <special-character-tip :texts="specialCharCheck['consigneeLine'+i]">
                <cargo-input
                  :ref="'consigneeLine'+i"
                  v-model="form['consigneeLine'+i]"
                  :disabled="readonly"
                  :no="'consigneeLine'+i"
                  :placeholder="placeholderSFT(i)"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField['consigneeLine'+i] ? 'red-border' : ''"
                  @change="()=>wrapAddr(form,'consigneeLine'+i,i+1 > 6 ? null :'consigneeLine'+(i+1),200)"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,notUppercaseShipperConsigneNotify,{autoHalfWord:true,autoUppercase:notUppercaseShipperConsigneNotify})"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
          <el-form
            label-width="50px"
            label-position="left"
            style="position:relative;margin-right:20px"
          >
            <char-count :form="form" prefix="notify" />
            <el-form-item
              :label="$t('SeaExport.NotifyParty')"
            >
              <cargo-input v-model="form.notifyCode" no="notifyCode" :class="importDifferenceField.notifyCode ? 'red-border' : ''" style="width:115px;margin-right: 5px" :placeholder="readonly ? '' : $t('SeaExport.NotifyId')" :auto-uppercase="notUppercaseShipperConsigneNotify" :disabled="readonly" />
              <cargo-company-select
                no="notifyId"
                :disabled="readonly"
                :method-params="{notify:true,active:true}"
                :default-value="form.notifyId||''"
                style="display: inline-block;width:145px;"
                :class="importDifferenceField.notifyId ? 'red-border' : ''"
                @change="data => {pm.notifyChange(data)}"
              />
            </el-form-item>
            <el-form-item
              v-for="i in 7"
              :key="i"
              label-width="0"
            >
              <special-character-tip :texts="specialCharCheck['notifyLine'+i]">
                <cargo-input
                  :ref="'notifyLine'+i"
                  v-model="form['notifyLine'+i]"
                  :disabled="readonly"
                  :no="'notifyLine'+i"
                  :placeholder="placeholderSFT(i)"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField['notifyLine'+i] ? 'red-border' : ''"
                  @change="()=>wrapAddr(form,'notifyLine'+i,i+1 > 6 ? null :'notifyLine'+(i+1),200)"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,notUppercaseShipperConsigneNotify,{autoHalfWord:true,autoUppercase:notUppercaseShipperConsigneNotify})"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
          <div>
            <span style="display:inline-block;line-height:28px;padding-bottom: 5px;">{{
              $t('SeaExport.SecondNotifyParty')
            }}</span>
            <cargo-rich-textarea
              v-model="form.alsoNotify"
              no="alsoNotify"
              :disabled="readonly"
              :text-chars="0"
              wrap-symbol="r"
              style="width: 310px;height: 230px;"
              :class="importDifferenceField.alsoNotify ? 'red-border' : ''"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),form.alsoNotify,val=>{form.alsoNotify=val}, notUppercaseShipperConsigneNotify,{warningCount:45,maxChar: 0,autoHalfWord:true,autoUppercase:notUppercaseShipperConsigneNotify})"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ContactPerson"
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-position="right"
        label-width="100px"
      >
        <el-form-item :label="$t('SeaExport.ContactPerson')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.role"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.telephone"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.mobile"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.fax"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.email"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- SOP接收人弹窗 -->
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="form"
      :agent="sopDialog.agent"
      lob="SE"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog
      :visible.sync="transcribeDialog.visible"
      :job="form"
      @callback="transcribeCallback"
    />
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      @callback="hsCodeSearchDialog.successCallback"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      :visible.sync="selectOperationReqDialog.visible"
      lob="SE"
      :value="selectOperationReqDialog.value"
      @callback="val=>form.operationContent=val"
    />
    <!-- 附加费条款弹窗 -->
    <select-surcharge-terms-dialog
      :visible.sync="selectSurchargeTermsDialog.visible"
      :job-uuid="form.uuid"
      :row-data="selectSurchargeTermsDialog.rowData"
      :disabled="readonly"
      @callback="handleSurchargeTerms"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      @callback="codeSearchCallback"
    />
    <!-- Fba收发通地址弹窗 -->
    <fba-bill-address-dialog
      :visible.sync="fbaBillAddressDialog.visible"
      :job="fbaJob"
      @callback="fbaCodeSearchCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
  </div>
</template>

<script>
import { TabBookingFCLPM } from './tabBookingFCLPM'
import sopPic from '@/assets/sop.png'
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import sopDialog from '@/components/Cargo/Job/sopDialog'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import bookingBulkDataGrid from '@/components/Cargo/Job/bookingBulkDataGrid'
import bookingSpecialDataGrid from '@/components/Cargo/Job/bookingSpecialDataGrid'
import transcribeDialog from '@/components/Cargo/Job/transcribeDialog'
import hsCodeSearchDialog from '@/components/Cargo/Job/hsCodeSearchDialog'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import specialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import selectOperationReqDialog from '@/components/Cargo/Job/selectOperationReqDialog'
import selectSurchargeTermsDialog from '@/components/Cargo/Job/selectSurchargeTermsDialog'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import selectData from '@/utils/selectData'
import ColumnUtils from '@/utils/ColumnUtils'
import { getCacheListByKey, getObjectByCache, getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import {
  CONTAINERLOAD_TYPES
} from '@/class/cargo/model/parameters/ContainerLoadType'
import { BOOKING_TERMS } from '@/class/cargo/model/parameters/SeaExportConstants'
import { SPLIT_BILL_TYPE } from '@/class/cargo/model/parameters/BillType'
import {
  BRING_OUT_LOGIC_CALL_SOURCE_SE_BOOKING,
  CARGO_SOURCES, EXPORT_CONTROLLED_PRODUCT, RATE_TYPE,
  SALES_CHANNEL_OCR_RECOGNITION, TAX_NATURES
} from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { Contract } from '@/class/model/mdm/Contract'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { updateTrackingForDocumentType } from '@/api/fileHistory'
import { validateReleaseNumberCustomer } from '@/api/company'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import lang from '@/lang'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import stampIcon from '@/assets/stamp.jpg'
import StampPictureView from '@/components/Cargo/Job/stampPictureView'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import checkPermission from '@/utils/permission'
import StrUtils from '@/utils/StrUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { dateCompare } from '@/utils/commonUtil'
import { FbaJob } from '@/class/model/booking/FbaJob'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import fbaBillAddressDialog from '@/views/cargo/v0/FBA/Order/billAddressDialog'
import { getJobAvailableChannels } from '@/api/Fba/fbaChannel'
import { getUserInfo } from '@/utils/auth'
import { searchCustomerPrice } from '@/api/price/fbaQuotation'
import { FbaQuotationUtil } from '@/class/cargo/model/utils/FbaQuotationUtil'
import { Charge } from '@/class/model/act/Charge'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'
import { FbaQuotation } from '@/class/model/price/FbaQuotation'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { syncAtdInfo, syncAtaInfo } from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceUtil'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import { checkPoNoIsExist } from '@/api/booking/job'
import { getPartnerByPoNo } from '@/api/projectManage/project'
import warehouseNoInput from '@/components/Cargo/Job/warehouseNoInput'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import customsDeclaration from '@/components/Cargo/Job/customsDeclaration'
import * as NumberUtils from '@/utils/NumberUtils'
import { CargoDoc } from '@/class/model/booking/CargoDoc'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import microApp from '@micro-zoe/micro-app'
// import $store from '@/store'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'TabBookingFCL',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE':
          return lang.t('SeaExport.TUE')
        case 'WED':
          return lang.t('SeaExport.WED')
        case 'THU':
          return lang.t('SeaExport.THU')
        case 'FRI':
          return lang.t('SeaExport.FRI')
        case 'SAT':
          return lang.t('SeaExport.SAT')
        case 'SUN':
          return lang.t('Pricing.Sun')
        case 'MON':
        default:
          return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    AutoNumberInput,
    StampPictureView,
    cargoAdvanceSelect,
    cargoInput,
    cargoButtonContainer,
    sopDialog,
    bookingSeaEqDataGrid,
    bookingBulkDataGrid,
    bookingSpecialDataGrid,
    transcribeDialog,
    hsCodeSearchDialog,
    cargoDepartmentNewSelect,
    cargoDepartmentSelect,
    cargoOfficeSelect,
    cargoUserSelect,
    cargoCompanySelect,
    cargoProjectSelect,
    cargoPackingSelect,
    specialRequestsGrid,
    selectOperationReqDialog,
    selectSurchargeTermsDialog,
    billAddressDialog,
    cargoRichTextarea,
    specialCharacterTip,
    fbaBillAddressDialog,
    CargoSalesCompanySelect,
    warehouseNoInput,
    customsDeclaration
  },
  mixins: [BasicTabMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      default: ''
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    isFba: { // 是否是FBA业务
      type: Boolean,
      default: false
    },
    processingPromiseList: { // 正在处理中的异步操作对象列表
      type: Array,
      default: () => []
    },
    slaveCustomsDeclarationEnable: { // 【小票】关单信息 是否可用
      type: Boolean,
      default: false
    },
    differenceJob: { // 差异字段标红
      type: Object,
      default: () => ({})
    },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      jobData: {}, TYPE_NAMES,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabBookingFCLPM(this),
      sopPic,
      SEUtils,
      URL,
      SystemConstants,
      FbaJobConstants,
      WarehouseInState,
      selectTypeNames: TYPE_NAMES,
      contractStatuses: selectData.contractStatuses,
      containerLoadTypes: CONTAINERLOAD_TYPES,
      CARGO_SOURCES,
      TAX_NATURES,
      EXPORT_CONTROLLED_PRODUCT,
      rateType: RATE_TYPE,
      bookingTerms: BOOKING_TERMS,
      partnerManagementMode: 0,
      lclslaveEnabled: false, // 拼箱小票
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      branchOfficeCheck: false,
      creditOpen: false,
      openProjectConfig: false,
      openWarehouse: false,
      salesCanSeeBookingAgent: false,
      sopConfigOpen: false,
      sopImageA: false,
      sopImageB: false,
      sopImageC: false,
      selectedLocalAddedService: [],
      localAddedService: [],
      selectedPodAddedService: [],
      podAddedService: [],
      addrPM: new BillAddressCommonPM(this),
      form: new SeaExportJob().fillDefaultValue().getData(),
      mblDoc: new SeaCargoDoc().fillDefaultValue().getData(),
      hdoc: new SeaCargoDoc().fillDefaultValue().getData(),
      jobWarehouseNos: [],
      delPoItemsUuids: [], // 需要删除的 关单信息
      seaEqList: [],
      cargoBulkDetailList: [],
      specialCharCheck: {
        cargoEnglishName: null,
        mark: null,
        shipperLine1: null,
        shipperLine2: null,
        shipperLine3: null,
        shipperLine4: null,
        shipperLine5: null,
        shipperLine6: null,
        shipperLine7: null,
        consigneeLine1: null,
        consigneeLine2: null,
        consigneeLine3: null,
        consigneeLine4: null,
        consigneeLine5: null,
        consigneeLine6: null,
        consigneeLine7: null,
        notifyLine1: null,
        notifyLine2: null,
        notifyLine3: null,
        notifyLine4: null,
        notifyLine5: null,
        notifyLine6: null,
        notifyLine7: null
      },
      showWarningImageA: false,
      warningImageATip: '',
      showWarningImageB: false,
      warningImageBTip: '',
      showWarningImageC: false,
      warningImageCTip: '',
      customerLevel: {
        level: '',
        customerName: ''
      },
      advancePaymentLabel: '', // 预付款(中邮)
      contractStatus: 0,
      contractStatusLabel: '',
      customerTip: '',
      contactList: [],
      etdEnabled: false,
      cargoSourceEnabled: false,
      warehouseNameList: [],
      salesList: null,
      salesPrompt: '',
      txtWhs: '', // 入库信息
      txtSalesOffice: '', // 销售所在分公司
      opEabled: false,
      overseaAgentUsersList: [], // 海外客服用户列表
      txtSurchargeTerms: '', // 附加费条款
      contactDialog: {
        visible: false,
        data: {}
      },
      wtCreateCompany: this.$checkPermission(['button_partner_wtCreateCompany']),
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      sopDialog: {
        visible: false,
        cmpIdx: 0,
        agent: '',
        contactList: []
      },
      transcribeDialog: {
        visible: false
      },
      hsCodeSearchDialog: {
        visible: false,
        title: '',
        successCallback: () => {
        }
      },
      selectOperationReqDialog: {
        visible: false,
        value: ''
      },
      selectSurchargeTermsDialog: {
        visible: false,
        rowData: []
      },
      billAddressDialog: {
        visible: false
      },
      fbaBillAddressDialog: { // Fba收发通地址
        visible: false
      },
      stampIcon, // 订舱章
      stampPictureView: {
        businessDocuments: [], // 不为空则显示订舱章
        visible: false
      },
      isTabContainerInfo: true, // // CARGO-7908 当基本页签切换非装箱信息页签不去覆盖基本页签实际件毛体(cargo 中在bookingworkspace 中设置的是true)
      btnSave: true,
      overseaAgentDataProviderChange: false, // 目的港代理数据源是否发生变更
      bookingAgentDataProviderChange: false, // 订舱代理数据源是否发生变更
      customerRefNoTip: '', // 业务参考号鼠标悬浮提示
      markChange: false,
      cargoEnglishNameChange: false,
      oldMark: '',
      oldCargoEnglishName: '',
      showMarkOrCargoEnglishNameDialog: false, // 英文品名唛头是否双击展示
      backUpWarehouseCompanyList: [], // 合作伙伴类型为仓库，并且仓库类型为前置仓的有效数据
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      fbaJob: new FbaJob().fillDefaultValue().getData(), // fbaJob
      tenantId: 0,
      channel4JobSelect: [],
      cargoType4JobSelect: [],
      fbaQuotation: null,
      fbaChannel: null,
      serviceChannel: null,
      chargingMethod: '',
      destinationDistribution: '',
      bubbleSplittingRatio: 0.0,
      bubbleCountingRatio: 0.0,
      fbaGoods: [], // fba货物明细
      countryList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      JobUtils,
      loadingPortChanged: false, // 起运港是否发生变更
      ataChanged: false, // ATA是否发生变更
      warehouseNoRed: '',
      customerRefNoRed: '',
      needConfirmProjectNo: false,
      poNoRed: false,
      isProjectLinkedCustomer: false,
      projectList: [],
      jingyuWarehouse: false,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      importDifferenceField: {},
      cargoSalesList: null,
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      transportationModeInfos: [],
      showCharacteristic: false,
      isTP: false, // 太平
      toExoSystemJYD: false, // 集翊达
      isZY: false, // 显示中邮选项
      isXy: false,
      isHC: false,
      isShowContactPersonDetail: false, // 海创显示详细信息
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      operationDateData: { // 子应用操作日期
        filedLable: 'SeaExport.OperationDate',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'operationDate',
        fieldData: this.form ? this.form.customsDate : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: ''
      },
      saleRoleHideData: { // 销售角色
        viewSource: 'RemoteBooking',
        hide: false
      },
      operationDateQuery: { // 操作日期查询条件、显示列
        viewSource: 'SopBoard',
        searchItem: false, // 查询条件
        columnItem: false // 显示列
      },
      userDefinedRoleData: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole1',
        labelWidth: '108px',
        labelPosition: 'right',
        no: 'userDefinedRoleId1',
        fieldData: this.form ? this.form.userDefinedRoleId1 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole1',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  computed: {
    isXhqAdd() { // 智能托书识别新增业务
      return this.$route.query.action === 'add'
    },
    provisionEtdLocked() {
      return !!(this.provisionLock && this.provisionLock.etdLocked)
    },
    isXhq() {
      return this.config && this.config.get('SmartTrustChannel') === 'xhq'
    },
    isXhqSync() { // 智能托书识别新增业务同步信息  this.form.danUNNo 智能托书UUID
      return !this.form.uuid && this.form.danUNNo && (this.isXhqAdd || this.isXhq)
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    // 是否为海运订舱极速版页面
    isBookingNew() {
      return this.$route.path.toLowerCase() === '/SeaExport/BookingNew'.toLowerCase() || this.$route.path.toLowerCase() === '/FBA/FBABookingNew'.toLowerCase() || this.$route.path.toLowerCase() === '/SeaExport/BookingVerify'.toLowerCase()
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !this.form.printHblZbLock && (!this.form.uuid || (this.form.uuid && checkPermission(['tab_SEBooking_EditBookingTab'])))
    },
    // 通过正本打印锁定业务
    lockJobByPrintHblZb() {
      if (!this.cooperateEdit) return false
      if (this.action !== 'look' && (!this.form.uuid || (this.form.uuid && checkPermission(['tab_SEBooking_EditBookingTab'])))) {
        return this.form.printHblZbLock
      }
      return false
    },
    mblOnly() {
      return this.form.mblOnly
    },
    isHbl() {
      return this.form.typeHBL === SPLIT_BILL_TYPE.code
    },
    bookingAgentEnabled() {
      return this.lclslaveEnabled && SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'bookingAgent') && ((this.pm.isJoinCarrierBookingAgent && this.form.containerLoadType !== 'BB') ? this.form.carrierId > 0 : true)
    },
    carrierIdEnabled() {
      return this.lclslaveEnabled && SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'carrierId')
    },
    designationAgentEnabled() {
      return this.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'designationAgent')
    },
    customsBrokerEnabled() {
      if (!this.form.customs) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'customsBroker')) {
        return false
      }
      return true
    },
    warehouseEabled() {
      if (!this.form.warehousing) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'warehouseCmp')) {
        return false
      }
      return true
    },
    cubageActualEnabled() {
      return this.isEdit && !this.pm.billChargeFlag && SecurityUtil.checkOffsetChargeMeasure(this.form, 'WCB')
    },
    saleEnabled() {
      return ((this.pm.trustFromEditSales ? true : !this.form.trustFromJob) || this.pm.isCrossTenant) &&
        this.pm.canChangeSalesOfJob && !this.pm.isWithinCloseAccountDate
    },
    config() {
      return this.context.config
    },
    customerEnabled() {
      // 开启参数1 且是被委托的业务，不可以改委托单位；relatedJobLob 与当前业务不同是出口转进口，没有值是跨租户委托
      if (this.config && Number(this.config.get('isNewDelegation')) === 1 && this.form.trustFromJob) {
        return false
      }
      return this.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'customerId')
    },
    chargeWeightEnabled() {
      return this.isEdit && SecurityUtil.checkOffsetChargeMeasure(this.job, 'WGTX')
    },
    showChannelNo() {
      return ['B2B', this.$t('Menu.WallTechFamily')].includes(this.form.salesChannel)
    },
    backUpWarehouseEnabled() {
      if (!this.form.backUpWarehouse) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'backUpWarehouse')) {
        return false
      }
      return true
    },
    destinations() { // 目的地 可选项
      return JobUtils.initDestination(this.fbaQuotation)
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    // bookingTermEditable() {
    //   return this.isEdit
    // }
    canEditInternalDelegatedJobField() { // 是否可以编辑内部委托业务字段 为true则不让编辑
      return this.config && Number(this.config.get('InternalCrossJobSynchronization')) === 1 &&
        this.form && !!this.form.relatedJob && !!this.form.relatedJobLob && !!(this.form.relatedJobLob === 'SE')
    },
    isCopy() {
      return this.action === 'copy'
    },
    // 销售分公司
    salesOffice() {
      return this.form.salesOffice
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.form.uuid)
    },
    isJydUpdateCustomsDate() { // 集翊达判断有编辑操作日期权限，不是则默认可以编辑
      return this.isJyd ? this.$checkPermission(['role_SEBooking_UpdateCustomsDate']) : true
    }
  },
  watch: {
    // 已订阅过货物计费项目时，修改了船公司则弹窗提醒
    'form.carrierId': {
      handler(newValue, oldValue) {
        this.jobData = new SeaExportJob(this.form)
        const goodsTracking = [
          'realArrivalsDate', 'estimatedArrivalTime', 'actualArrivalTime', 'estimatedPortDischargeTime', 'portDischargeTime',
          'estimatedRailwayDepartureTime', 'railwayDepartureTime', 'estimatedRailwayDischargeTime',
          'railwayDischargeTime', 'estimatedArrivalPlaceOfDelivery', 'actualArrivalPlaceOfDelivery', 'estimatedCustomsReleaseTime',
          'destPortCustomsClearanceTime', 'destPortInspection', 'destPortInspectionLevel', 'estimatedPickUpTime', 'actualPickUpTime', 'estimatedReturnTime', 'destPortReturnTime',
          'secondArrivalsDate', 'secondUnloadingDate', 'secondLoadingDate', 'secondShipmentDate', 'bargeETD', 'bargeETA']
        if (this.carrierIdEnabled && oldValue && this.isEdit && this.isWriteback(goodsTracking)) {
          if (newValue) {
            this.$confirm(this.$t('SeaExport.ShippingCompanyDialogModifyText'), this.$t('SeaExport.tip'), {
              confirmButtonText: this.$t('SeaExport.emptyDestinationInformation'),
              cancelButtonText: this.$t('SeaExport.noEmptyDestinationInformation'),
              type: 'info'
            }).then(() => {
              this.clearPortDestination(goodsTracking)
            }).catch(() => {})
          } else {
            this.$confirm(this.$t('SeaExport.ShippingCompanyDialogDeleteText'), this.$t('SeaExport.tip'), {
              confirmButtonText: this.$t('SeaExport.emptyDestinationInformation'),
              cancelButtonText: this.$t('SeaExport.noEmptyDestinationInformation'),
              type: 'info'
            }).then(() => {
              this.clearPortDestination(goodsTracking)
            }).catch(() => {})
          }
        }
      }
    },
    'form.transfering': {
      handler(value) {
        if (!value) {
          this.form.transferPortCode = ''
        }
      },
      deep: true
    },
    'form.bookingTerm': {
      handler(newVal) {
        this.pm.bookingTermChange(newVal)
      }
    },
    mblOnly(newVal) {
      if (newVal) {
        this.form.signHBL = false
      }
    },
    'form.surchargeTerms': {
      handler(newValue) {
        if (!newValue) {
          this.txtSurchargeTerms = ''
          return
        }
        let text = ''
        console.log('surchargeTerms', newValue)
        for (const item of newValue) {
          if (item.deleted) {
            continue
          }
          const chargeItemCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'chargecode')
          console.log('chargeItemCode', chargeItemCode)
          // if (chargeItemCode === 'HYF') {
          //   if (this.form.signMBL || (!this.form.signMBL && !this.form.signHBL)) {
          //     this.form.paymentTermMBL = item.terms
          //   } else {
          //     this.form.paymentTermHBL = item.terms
          //   }
          //   item.deleted = true
          //   continue
          // }
          if (text) {
            text += '\n'
          }

          const chargeItemName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'zhName')
          if (typeof chargeItemName === 'string' && chargeItemName.startsWith('HDS')) {
            this.form.hds = true
          }
          text += `${chargeItemName}：${item.terms}`
        }
        this.txtSurchargeTerms = text
      }
    },
    'form.customerId'(newVal) {
      if (this.form.fba && this.fbaJob) {
        this.fbaJob.customerId = newVal
      }
    },
    async slaveCustomsDeclarationEnable(newVal) {
      // SEMultiSoMode参数开启情况下，新增小票时，切换整拼类型【自拼箱-》非自拼箱，非自拼箱-》自拼箱】，清除原关单信息(主要清除默认生成的关单信息)
      if (this.isEdit && !this.form.uuid) {
        if (this.form.poItems && this.form.poItems.length > 0) {
          for (const item of this.form.poItems) {
            if (item.uuid) {
              this.delPoItemsUuids.add(item.uuid)
            }
          }
          this.form.poItems = []
        }
      }
      // 赋值/清空业务的关单号
      if (newVal) {
        await new SeaExportJob(this.form).getPoItems()
        const soNos = []
        if (this.form.poItems && this.form.poItems.length > 0) {
          for (const poItem of this.form.poItems) {
            if (poItem.soNo) {
              soNos.push(poItem.soNo)
            }
          }
        }
        this.form.soNo = soNos.join('\n')
      } else {
        this.form.soNo = ''
      }
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    this.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
    this.branchOfficeCheck = Number(this.config.get('departmentSalesOfficeCheck')) === 1
    this.creditOpen = Number(this.config.get('creditOpen')) === 1
    this.isAddUserDefinedRoles = Number(this.config.get('IsAddUserDefinedRoles')) === 1
    this.needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
    this.toExoSystemJYD = this.config.get('ToExoSystem') === 'JYD' // 集翊达 CARGO-42686
    this.isZY = String(this.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
    this.isShowContactPersonDetail = String(this.config.get('ToExoSystem')) === 'HC'
    this.isTP = String(this.config.get('ToExoSystem')) === 'TP'
    this.isXy = String(this.config.get('ToExoSystem')) === 'XYCW'
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    // const sop = await SopPushConfig.findByOfficeId(this.$store.getters.currentOfficeId)
    // if (sop) {
    //   this.sopConfigOpen = sop.ifAuto
    // }
    this.markChange = false
    this.cargoEnglishNameChange = false
    this.pm.init()
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
  },
  methods: {
    async onShow(row, isRefresh) {
      console.log('row----------------', row)
      if (!row.uuid) {
        row.booking = true
      }
      if (row.airLine) {
        this.pm.vesselLine = row.airLine
      }
      if (this.isEdit) {
        if (this.form.uuid) {
          this.opEabled = await SecurityUtil.canEdit(this.form, false)
        } else {
          this.opEabled = true
        }
      }
      if (!isRefresh) {
        this.pm.formInitialValue = { ...this.form }
        return
      }
      // 刷新 客户需求表格【控件里有监听委托单位的事件，这里不需要调用查询方法】
      // if (this.$refs['selectedSpecialRequest']) {
      //   this.$refs['selectedSpecialRequest'].toQuery()
      // }
      this.openProjectConfig = Number(this.config.get('openProjectConfig')) === 1
      this.openWarehouse = Number(this.config.get('isOpenWarehouse')) > 0
      this.salesCanSeeBookingAgent = Number(this.config.get('SalesCanSeeBookingAgent')) === 1
      this.isProjectLinkedCustomer = Number(this.config.get('isProjectLinkedCustomer')) === 1 // 项目是否和委托单位关联
      this.jingyuWarehouse = Number(this.config.get('JingyuWarehouse')) === 1
      const job = new SeaExportJob(row)
      console.log(job)
      this.fbaQuotation = null
      this.fbaChannel = null
      this.serviceChannel = null
      this.cargoType4JobSelect = []
      this.loadingPortChanged = false
      row.atdChanged = !!row.atdChanged
      row.ataChanged = false
      this.localAddedService = []
      this.podAddedService = []
      this.selectedLocalAddedService = []
      this.selectedPodAddedService = []
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      if (!row.uuid) {
        job.seaCargoDoc = job.seaCargoDoc || []
        // ocr跳转进来之后，空字符串的属性没带过来
        if (job.salesChannel === SALES_CHANNEL_OCR_RECOGNITION.code) {
          if (job.seaCargoDoc) {
            job.seaCargoDoc.forEach(item => {
              new SeaCargoDoc(item).fillDefaultValue()
            })
          }
          if (job.cargoDoc) {
            new CargoDoc(job.cargoDoc).fillDefaultValue()
            job.cargoDoc.forEach(item => {
              new SeaCargoDoc(item).fillDefaultValue()
            })
          }
        }
        this.mblDoc = await job.getMainMbl()
        if (!this.mblDoc) {
          this.mblDoc = new SeaCargoDoc().fillDefaultValue().getData()
          await this.initCargoDoc(this.mblDoc, row, 'MBL')
        }
        if (!this.mblDoc.cargoManifestName) {
          this.mblDoc.cargoManifestName = job.cargoEnglishName
        }
        this.hdoc = await job.getMainHbl()
        if (!this.hdoc || this.hdoc.releaseType && Object.keys(this.hdoc).length < 3) {
          const releaseType = this.hdoc ? this.hdoc.releaseType : null
          this.hdoc = new SeaCargoDoc().fillDefaultValue().getData()
          if (releaseType) {
            this.initCargoDocWithoutReleaseType(this.hdoc, row, 'HBL', releaseType)
          } else {
            await this.initCargoDoc(this.hdoc, row, 'HBL')
          }
        }
        if (!this.hdoc.cargoManifestName) {
          this.hdoc.cargoManifestName = job.cargoEnglishName
        }
        // 新增复制托书识别创建下， 根据船公司，船名获取ediCode
        await JobUtils.queryCarrierCodeHandler(job)
        this.seaEqList = job.seaEQ = job.seaEQ || []
        this.cargoBulkDetailList = job.cargoBulkDetail = job.cargoBulkDetail || []
        this.customerLevel.level = ''
        this.customerLevel.customerName = ''
        this.advancePaymentLabel = ''
        this.contractStatus = 0
        this.contractStatusLabel = ''
        this.customerTip = ''
        this.customerTip = ''
        if (row.paymentTermHBL === 'PP') {
          const ports = this.context.seaPortList.filter(p => p.code === row.loadingPortCode)
          if (ports && ports.length > 0) {
            row.paymentPlaceHBL = ports[0].englishName
          }
        } else if (row.paymentTermHBL === 'CC' || row.paymentTermHBL === '3P') {
          const ports = this.context.seaPortList.filter(p => p.code === row.destinationPortCode)
          if (ports && ports.length > 0) {
            row.paymentPlaceHBL = ports[0].englishName
          }
        }
        if (this.action === 'copy') {
          const billOfLadingSynMode = Number(this.config.get('BillOfLadingSynMode'))
          if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
            if (this.mblDoc && !this.mblDoc.chargeWeight) {
              this.mblDoc.chargeWeight = row.chargeWeight
            }
            if (this.hdoc && !this.hdoc.chargeWeight) {
              this.hdoc.chargeWeight = row.chargeWeight
            }
          }
        }
      } else {
        this.mblDoc = await job.getMainMbl()
        if (!this.mblDoc) {
          this.mblDoc = new SeaCargoDoc().fillDefaultValue().getData()
          await this.initCargoDoc(this.mblDoc, row, 'MBL')
        }
        this.hdoc = await job.getMainHbl()
        if (!this.hdoc) {
          this.hdoc = new SeaCargoDoc().fillDefaultValue().getData()
          await this.initCargoDoc(this.hdoc, row, 'HBL')
        }
        this.seaEqList = job.seaEQ || []
        this.cargoBulkDetailList = job.cargoBulkDetail
      }
      this.jobWarehouseNos = job.jobWarehouseNos || []
      this.importDifferenceField = row.differenceJobFields || {}
      this.form = row
      console.log('this.form===', this.form)
      console.log('this.importDifferenceField===', this.importDifferenceField)
      this.checkSpecialCharacter()
      this.pm.changeJob()
      this.pm.fillView()
      if (!this.form.uuid && this.form.customerId && Number(this.form.customerId) > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.form.customerId)
        if (company) {
          await this.customerIdChange2ContractHandler(company)
        } else {
          this.loadCustomerIdContractInfo()
        }
      } else {
        this.loadCustomerIdContractInfo()
      }
      this.cargoSourceEnabled = this.isEdit
      this.salesList = null
      this.salesPrompt = ''
      this.overseaAgentUsersList = []
      this.mergeSurchargeTerms()
      row.printHblZbLock = false
      this.overseaAgentDataProviderChange = false
      this.bookingAgentDataProviderChange = false
      JobUtils.setSailingDay(this.form)
      if (this.isEdit) {
        this.pm.checkValueMatch()
        this.setSecondaryCustomJobTypeFunc()
        this.setCustomJobTypeFunc()
        if (!row.uuid) {
          if (row.etd) {
            this.pm.ETDChange('')
          }
        }
        this.oldMark = this.form.mark
        this.oldCargoEnglishName = this.form.cargoEnglishName
      }

      // fba
      if (this.isEdit && this.form.fba) {
        await getJobAvailableChannels({ tenantId: this.tenantId }).then(res => {
          this.channel4JobSelect = res.data.filter(e => e.shippingType === 'SE')
        })
      }
      if (this.form.fba) {
        if (this.form.uuid || this.form.fbaJob) {
          this.fbaJob = this.form.fbaJob
        } else {
          this.fbaJob = new FbaJob().fillDefaultValue().getData()
          this.fbaJob.bubbleCountingRatio = 6000.0
        }
        this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
        this.chargingMethod = this.fbaJob.chargingMethod
        this.destinationDistribution = this.fbaJob.destinationDistribution
        this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
        this.bubbleSplittingRatio = this.fbaJob.bubbleSplittingRatio
        await this.changeChannelName(this.form.serviceChannel)
        this.serviceChannel = this.form.serviceChannel
        this.getCargoType()
        if (this.action === 'add') {
          this.form.containerLoadType = 'LCL'
        }
        // 初始化增值服务
        let valueAddedServices = []
        if (this.fbaJob.valueAddedServices && this.fbaJob.valueAddedServices.split(',').length > 0) {
          valueAddedServices = this.fbaJob.valueAddedServices.split(',')
        }
        const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_ValueAddedService)
        for (const item of res) {
          if (item.fbaSea) {
            switch (Number(item.serviceType)) {
              case 0:
                this.localAddedService.push(item)
                if (valueAddedServices.indexOf(item.code) >= 0) {
                  this.form[item.code] = true
                  this.selectedLocalAddedService.push(item.code)
                }
                break
              case 1:
                this.podAddedService.push(item)
                if (valueAddedServices.indexOf(item.code) >= 0) {
                  this.form[item.code] = true
                  this.selectedPodAddedService.push(item.code)
                }
                break
            }
          }
        }
      } else {
        this.cargoType4JobSelect = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType).filter(p => p.sea)
        if (this.form.cargoType) {
          const cargoTypeMatch = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType).filter(p => p.sea && p.code === this.form.cargoType)
          if (cargoTypeMatch && cargoTypeMatch.length > 0) {
            // 如果找到了，更新showCharacteristic属性
            this.showCharacteristic = cargoTypeMatch[0].showCharacteristics
          } else {
            this.showCharacteristic = false
          }
        }
      }
      if (this.form.warehouseNo) {
        this.pm.checkWarehouseNo()
      }
      // CARGO-33935 新增的时候，默认把卸货港代码同步到订舱页面
      if (this.action === 'add' && this.pm.sEUseDischargingPort5Code) {
        this.pm.refreshPortCode(this.form.dischargingPortCode, this.form.carrierId)
      }
      if (this.form.customerRefNo) {
        this.customerRefNoRed = await this.pm.checkCustomerRefNo()
      }
      if (!this.isEdit && this.form.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        this.poNoRed = await checkPoNoIsExist(this.form.poNo, this.form.uuid).then(res => res.data) > 0
      }
      // 智能托书识别生成业务
      this.syncInfoByZnts()
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness)
      if (this.slaveCustomsDeclarationEnable) {
        this.$nextTick(() => {
          if (this.$refs.customsDeclaration) {
            this.$refs.customsDeclaration.init()
          }
        })
      }
      this.$emit('showYdBookingResult', 'tabBookingFCL')
      if (this.$store.getters.enableFrontEndPlugin) {
        // this.setOperationDateData()
        // this.setUserDefinedRoleData()
        this.setUserDefinedRoleDataUI()
      }
    },
    // 智能托书识别生成业务同步信息
    async syncInfoByZnts() {
      if (!this.isXhqSync) return
      try {
        // 交货地
        if (!this.form.destinationPortCode && this.form.dischargingPortCode) {
          this.form.destinationPortCode = this.form.dischargingPortCode
        }
        // 交货地区域
        if (this.form.destinationPortCode) {
          const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', this.form.destinationPortCode)
          this.form.placeOfDeliveryRegion = port ? port.region : ''
        }
        if ((!this.form.csr || !this.form.dc)) {
          await JobUtils.matchUserPortConfig(this, this.form)
        }
        JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
        let isExcute = false
        if (!this.form.csr && !this.form.dc && this.form.customerId && Number(this.form.customerId) > 0) {
          const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.form.customerId)
          if (company) {
            isExcute = true
            await this.customerIdChange2ContractHandler(company)
          }
        }
        if (this.form.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 如果是指定货
          await this.pm.loadOverseaAgentDetailOwner(this.form.designationAgent) // 指定货带网管
          this.pm.loadOverseaAgentUserByLob(this.form.designationAgent)// 根据指定货确定海外客服
        } else {
          this.pm.loadOverseaAgentUserByLob(this.form.destinationAgent)// 还是根据目的港代理确定海外客服
        }
        // 整拼类型改变
        await this.pm.containerLoadTypeChange(this.form.containerLoadType, { preserveSeaEQ: this.isCopy && !!this.form.seaEQ && this.form.seaEQ.length > 0 })

        // CARGO-41312 集翊达：人员岗位带出逻辑调整，托书识别的销售逻辑处理
        // 根据委托单位带销售，只带销售，其它岗位不处理
        if (!isExcute && this.form.customerId && Number(this.form.customerId) > 0) {
          this.pm.loadCompanyUserForSalesAndCargoSales()
        }
        await JobUtils.initJobRoleOptionAfterMatchUserPortConfig(this.form)
      } catch (c) {
        this.$logger.error(c)
      }
    },
    clearPortDestination(goodsTracking) {
      for (const item of goodsTracking) {
        this.jobData[item] = ''
      }
    },
    isWriteback(goodsTracking) {
      const arr = []
      for (const item of goodsTracking) {
        if (this.jobData[item]) {
          arr.push(this.jobData[item])
        }
      }
      return arr.length
    },
    checkSpecialCharacter() {
      if (Number(this.config.get('SpecialCharacterCheck')) === 1) {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.form[key])
        }
      } else {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = null
        }
      }
    },
    async initCargoDoc(doc, row, docType) {
      new SeaCargoDoc(doc).reset()
      doc.docType = docType
      doc.mark = row.mark
      doc.cargoEnglishName = row.cargoEnglishName
      // if (docType === 'MBL') {
      doc.notifyLine1 = 'SAME AS CONSIGNEE'
      // }
      // 提单发货地，应该是seaopinput.placeOfReceipt
      doc.dispatchingPlace = row.dispatchingPlace
      doc.dispatchingPlaceCode = row.dispatchingPlaceCode
      // 提单起运港
      if (row.loadingPortCode) {
        console.log('posr', this)
        const ports = this.context.seaPortList.filter(p => p.code === row.loadingPortCode)
        if (ports && ports.length > 0) {
          doc.loadingPort = ports[0].englishName
          doc.loadingPortCode = row.loadingPortCode
        }
      }
      // 提单卸货港
      if (row.dischargingPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.dischargingPortCode)
        if (ports && ports.length > 0) {
          doc.dischargingPort = ports[0].englishName
          doc.dischargingPortCode = row.dischargingPortCode
        }
      }
      // 提单目的港
      if (row.destinationPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.destinationPortCode)
        if (ports && ports.length > 0) {
          doc.destinationPort = ports[0].englishName
          doc.destinationPortCode = row.destinationPortCode
        }
      }
      if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
        // 提单收货地
        doc.destinationPlace = row.destinationPlace
      }
      if (doc.docType === 'MBL' && row.masterFlag) {
        doc.shipperLine1 = this.office.seaAddressLine1
        doc.shipperLine2 = this.office.seaAddressLine2
        doc.shipperLine3 = this.office.seaAddressLine3
        doc.shipperLine4 = this.office.seaAddressLine4
        doc.shipperLine5 = this.office.seaAddressLine5
        doc.shipperLine6 = this.office.seaAddressLine6
      }
      // 通过参数BillOfLadingSynMode同步件毛体和包装
      CargoDocUtil.changeJobSynToBillOfLading(row, doc)
      // 根据参数判断是否同步小件数包装
      const isInsidePacking = Number(this.config.get('seaInsidePacking'))
      if (isInsidePacking === 1) {
        doc.insidePacking = row.insidePacking
      }
      // doc.issuerBL = 'UBI'
      ColumnUtils.customOrderFormTypeFunc(doc)
      // 新增时，如果已经选择提单方式，会重置为默认值
      if (!doc.releaseType) {
        const releaseType = Number(this.config.get('ReleaseTypeDefaultValue'))
        if (releaseType === 1) {
          doc.releaseType = 1
          doc.blNumber = 'THREE'
        } else if (releaseType === 2) {
          doc.releaseType = 2
          doc.blNumber = 'ONE'
        } else if (releaseType === 3) {
          doc.releaseType = 3
          doc.blNumber = 'ONE'
        } else if (releaseType === 4) {
          let type
          if (doc.docType === 'MBL') {
            type = LocalStorageUtilsNew.getConfiguration('SE_MBL_BL_MODEL')
          } else if (doc.docType === 'HBL') {
            type = LocalStorageUtilsNew.getConfiguration('SE_HBL_BL_MODEL')
          }
          doc.releaseType = type || 1
          doc.BLNumber = 'ONE'
          if (doc.releaseType === 1) {
            doc.BLNumber = 'THREE'
          }
        }
      } else { // 重置提单份数
        if (doc.releaseType === 1) {
          doc.BLNumber = 'THREE'
        } else {
          doc.BLNumber = 'ONE'
        }
      }
      doc.state = 1
      await JobUtils.handlerCargoDocLinebreaks(doc)
      row.seaCargoDoc.push(doc)
    },
    initCargoDocWithoutReleaseType(doc, row, docType, releaseType) {
      new SeaCargoDoc(doc).reset()
      doc.docType = docType
      doc.mark = row.mark
      doc.cargoEnglishName = row.cargoEnglishName
      // if (docType === 'MBL') {
      doc.notifyLine1 = 'SAME AS CONSIGNEE'
      // }
      // 提单发货地，应该是seaopinput.placeOfReceipt
      doc.dispatchingPlace = row.dispatchingPlace
      doc.dispatchingPlaceCode = row.dispatchingPlaceCode
      // 提单起运港
      if (row.loadingPortCode) {
        console.log('posr', this)
        const ports = this.context.seaPortList.filter(p => p.code === row.loadingPortCode)
        if (ports && ports.length > 0) {
          doc.loadingPort = ports[0].englishName
          doc.loadingPortCode = row.loadingPortCode
        }
      }
      // 提单卸货港
      if (row.dischargingPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.dischargingPortCode)
        if (ports && ports.length > 0) {
          doc.dischargingPort = ports[0].englishName
          doc.dischargingPortCode = row.dischargingPortCode
        }
      }
      // 提单目的港
      if (row.destinationPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.destinationPortCode)
        if (ports && ports.length > 0) {
          doc.destinationPort = ports[0].englishName
          doc.destinationPortCode = row.destinationPortCode
        }
      }
      if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
        // 提单收货地
        doc.destinationPlace = row.destinationPlace
      }
      if (doc.docType === 'MBL' && row.masterFlag) {
        doc.shipperLine1 = this.office.seaAddressLine1
        doc.shipperLine2 = this.office.seaAddressLine2
        doc.shipperLine3 = this.office.seaAddressLine3
        doc.shipperLine4 = this.office.seaAddressLine4
        doc.shipperLine5 = this.office.seaAddressLine5
        doc.shipperLine6 = this.office.seaAddressLine6
      }
      // 通过参数BillOfLadingSynMode同步件毛体和包装
      CargoDocUtil.changeJobSynToBillOfLading(row, doc)
      // 根据参数判断是否同步小件数包装
      const isInsidePacking = Number(this.config.get('seaInsidePacking'))
      if (isInsidePacking === 1) {
        doc.insidePacking = row.insidePacking
      }
      // doc.issuerBL = 'UBI'
      ColumnUtils.customOrderFormTypeFunc(doc)
      // 新增时，如果已经选择提单方式，会重置为默认值
      doc.releaseType = releaseType
      if (!doc.releaseType) {
        const releaseType = Number(this.config.get('ReleaseTypeDefaultValue'))
        if (releaseType === 1) {
          doc.releaseType = 1
          doc.blNumber = 'THREE'
        } else if (releaseType === 2) {
          doc.releaseType = 2
          doc.blNumber = 'ONE'
        } else if (releaseType === 3) {
          doc.releaseType = 3
          doc.blNumber = 'ONE'
        } else if (releaseType === 4) {
          let type
          if (doc.docType === 'MBL') {
            type = LocalStorageUtilsNew.getConfiguration('SE_MBL_BL_MODEL')
          } else if (doc.docType === 'HBL') {
            type = LocalStorageUtilsNew.getConfiguration('SE_HBL_BL_MODEL')
          }
          doc.releaseType = type || 1
          doc.BLNumber = 'ONE'
          if (doc.releaseType === 1) {
            doc.BLNumber = 'THREE'
          }
        }
      } else { // 重置提单份数
        if (doc.releaseType === 1) {
          doc.BLNumber = 'THREE'
        } else {
          doc.BLNumber = 'ONE'
        }
      }
      doc.state = 1
      row.seaCargoDoc.push(doc)
    },
    showContactDialog() {
      if (!this.form.customerContact) {
        return
      }
      for (const item of this.contactList) {
        if (item.contactPerson === this.form.customerContact) {
          this.contactDialog.data = item
          this.contactDialog.visible = true
          return
        }
      }
      this.contactDialog.data = {}
      this.contactDialog.visible = true
    },
    bubbleCountingChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.BubbleCountingRatio')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.bubbleCountingRatio = this.bubbleCountingRatio
      } else {
        if (this.fbaJob.bubbleCountingRatio > 9999) {
          this.fbaJob.bubbleCountingRatio = 9999
          this.bubbleCountingRatio = 9999
        } else {
          this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
        }
      }
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      if (title === this.$t('SeaExport.EnglishDescriptionOfGoods') || title === this.$t('SeaExport.Marks')) {
        this.showMarkOrCargoEnglishNameDialog = true
      }
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      this.showMarkOrCargoEnglishNameDialog = false
    },
    // 加载委托单位签约信息
    async loadCustomerIdContractInfo() {
      let company = this.context.companyList.find(p => p.cmpIdx === this.form.customerId)
      this.showWarningImageB = false
      this.sopImageB = false
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.stampPictureView.businessDocuments = []
      if (!company || !company.cmpIdx) {
        return
      }
      company = new Company(company)
      if (this.creditOpen) {
        this.pm.checkCreditByCompany(company.cmpIdx, 1)
      }
      await this.loadCustomerDetial(company)
      this.pm.getContractStatus(company) // 获取合约状态
      this.contactList = await Company.loadContact(company.uuid)
    },
    // 判断选中的委托单位，是否禁止到期合同创建业务，CARGO-7885
    async customerIdChange2ContractHandler(company) {
      this.showWarningImageB = false
      this.sopImageB = false
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.cargoSalesList = null
      this.stampPictureView.businessDocuments = []

      this.pm.customerIdChangeJobPropertiesHandler(company.cmpIdx, BRING_OUT_LOGIC_CALL_SOURCE_SE_BOOKING.code)

      if (!company.cmpIdx) {
        this.pm.getTxtSalesPrompt()
        return
      }
      const validateRes = await validateReleaseNumberCustomer({
        companyId: company.cmpIdx,
        officeId: this.$store.getters.currentOfficeId
      })
      if (validateRes && validateRes.data && validateRes.data.allowed === false) {
        if (validateRes.data.message) {
          this.$message.warning(validateRes.data.message)
        }
        this.form.customerId = 0
        console.log('[ReleaseNumber] SE tabBookingFCL clear', !!this.$refs.customerSelect)
        if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
          this.$refs.customerSelect.clear()
        }
        return
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      // 欧坚委托单位是否风险客户
      await JobUtils.checkRiskyCustomersByByCustomerId(company.cmpIdx, StrUtils.isEmpty(this.form.uuid))
      // 这个验证必须在 this.form.customerId = company.cmpIdx 赋值之前，否则此验证无意义
      SEUtils.refreshChargeAccountId(this.form, 'customerId', this.$t('SeaExport.ConsignationCompany'), this.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      this.form.customerId = company.cmpIdx

      company = new Company(company)
      if (this.creditOpen) {
        this.pm.checkCreditByCompany(company.cmpIdx, 1)
        this.pm.checkNewJobCreditInfo()
      }
      const days = await JobUtils.checkEtdDaysCreditInfo(company.cmpIdx)
      if (days > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EtdExceedsDays'))
        this.form.customerId = 0
        return
      }
      const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
      if (isForbid) {
        this.form.customerId = 0
        this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
        return
      }

      // 合同限制校验：检查是否启用合同限制且可放号天数<=0
      const contractLimitEnabled = company.contractLimitEnabled
      const availableDays = company.availableReleaseDays

      // contractLimitEnabled 可能是 '1' 或 1
      if (contractLimitEnabled === '1' || contractLimitEnabled === 1) {
        // availableReleaseDays 可能是数字或字符串，需要转换
        const daysNum = parseInt(availableDays) || 0
        if (daysNum <= 0) {
          const companyName = company.chineseName || company.englishName || '该委托单位'
          this.$message.warning(`${companyName} 未上传合同/合同失效，无法放号，请联系客户管理人员`)
          this.form.customerId = 0
          if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
            this.$refs.customerSelect.clear()
          }
          return
        }
      }

      if (company.incoTerm) {
        const incoTerm = company.incoTerm.split(',')
        if (incoTerm.length > 0) {
          this.form.incoTerm = incoTerm[0]
        }
      }
      await this.loadCustomerDetial(company)
      this.pm.getContractStatus(company) // 获取合约状态
      this.contactList = await Company.loadContact(company.uuid)
      // const contact = this.getDefaultContact(this.contactList)
      // this.form.customerContact = contact ? contact.contactPerson : ''
      this.form.customerContact = JobUtils.getCustomerContact(company.uuid, this.contactList)
      this.pm.onCustomerContactLoad()
      await this.pm.onCustomerDetailLoad()
      this.pm.loadCustomerPortDestinationAgents()
      this.pm.loadCompanyUser(1) // 销售
      if (this.fbaJob.serviceChannel && this.form.chargeWeight && this.form.chargeWeight > 0) {
        await this.$confirm(this.$t('FbaJob.changeCustomer'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
      if (company.mustInputScn) {
        this.form.editCftMode = true
      }
      this.context.reloadCharge = true
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness, true)
    },
    getCargoType() {
      this.cargoType4JobSelect = []
      const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType)
      let acceptableGoods = []
      if (this.fbaQuotation) {
        acceptableGoods = this.fbaQuotation.acceptableGoods.split(',')
      }
      for (const item of res) {
        if (this.fbaQuotation) {
          const valid = acceptableGoods && acceptableGoods.length > 0 && acceptableGoods.indexOf(item.code) > -1
          if (!valid) {
            continue
          }
        }
        if (item.fbaSea) {
          this.cargoType4JobSelect.push(item)
        }
      }
      if (this.form.cargoType && this.cargoType4JobSelect.map(item => item.code).indexOf(this.form.cargoType) === -1) {
        this.form.cargoType = ''
      }
    },
    addedServiceChangeHandler() {
      this.fbaJob.valueAddedServices = this.selectedLocalAddedService.concat(this.selectedPodAddedService).join(',')
    },
    singleAddedServiceChangeHandler(val, item) {
      this.form[item.code] = val
      // 需特殊处理的增值服务，如新增页签
      // 报关
      if (item.code === 'customs') {
        this.form.customsBroker = val ? this.form.customsBroker : 0
      }
      // MBL
      if (item.code === 'signMBL') {
        this.pm.isMBLChange()
      }
      // HBL
      if (item.code === 'signHBL') {
        this.pm.isHBLChange()
      }
      // virtualHBL
      if (item.code === 'virtualHBL') {
        this.pm.virtualHblChange()
      }
    },
    // 更改服务渠道
    async changeServiceChannel(channel) {
      if (!channel) {
        this.serviceChannel = null
        this.fbaChannel = null
        this.fbaQuotation = null
        this.form.fbaChannel = this.fbaChannel
        this.form.fbaQuotation = this.fbaQuotation
        return
      }
      let update = false
      let refreshCharge = false
      if (typeof this.form.customerId === 'number' && this.form.customerId > 0) {
        await this.changeChannelName(channel)
        const containCustomer = await this.checkChangeChannel()
        if (containCustomer) {
          if (typeof this.fbaJob.warehouseCode === 'string' && this.fbaJob.warehouseCode) {
            // 判断区中是否包含该目的地
            if (this.checkWarehouseCode()) {
              // 判断计费重量是否有值
              if (this.form.customerId && this.form.chargeWeight && this.form.chargeWeight > 0) {
                await this.$confirm(this.$t('FbaJob.refreshCharge'), this.$t('Message.Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                  cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                  type: 'warning'
                }).then(() => {
                  refreshCharge = true
                }).catch(() => {
                })
              }
            } else {
              await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), this.form.warehouseCode), this.$t('Message.Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                type: 'warning'
              })
              this.form.warehouseCode = ''
            }
          }
          update = true
        } else {
          await this.$confirm(this.$t('FbaJob.changeChannel'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            cancelButtonText: this.$t('CargoMsg.Cargo_No'),
            type: 'warning'
          }).then(async() => {
            update = true
            if (!this.checkWarehouseCode()) {
              this.form.warehouseCode = ''
            }
          }).catch(async() => {
            this.fbaJob.serviceChannel = this.serviceChannel
            await this.changeChannelName(this.serviceChannel)
            return Promise.reject(this.$t('Message.EditCancelled'))
          })
        }
      } else {
        if (typeof this.form.warehouseCode === 'string' && this.form.warehouseCode) {
          // 判断区中是否包含该目的地
          if (!this.checkWarehouseCode()) {
            await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), this.form.warehouseCode), this.$t('Message.Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
              type: 'warning'
            })
            this.form.warehouseCode = ''
          }
        }
        update = true
      }
      if (update) {
        this.serviceChannel = channel
        await this.changeChannelName(channel)
        this.fbaJob.serviceChannel = channel
        await this.checkCargoType()
        if (this.fbaChannel) {
          this.syncJobInfoByChannel()
        }
        this.getCargoType()
      }
      if (refreshCharge) {
        // 刷新费用
        await this.refreshCharge()
      }
    },
    // 更新渠道同步业务字段
    syncJobInfoByChannel() {
      this.fbaJob.chargingMethod = this.fbaChannel.chargingMethod + ''
      this.fbaJob.destinationDistribution = this.fbaChannel.destinationDistribution + ''
      this.fbaJob.bubbleCountingRatio = this.fbaChannel.bubbleCountingRatio
      this.fbaJob.bubbleSplittingRatio = this.fbaChannel.bubbleSplittingRatio
      this.chargingMethod = this.fbaJob.chargingMethod
      this.destinationDistribution = this.fbaJob.destinationDistribution
      this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
      this.bubbleSplittingRatio = this.fbaJob.bubbleSplittingRatio
    },
    // 更改目的地
    async changeWarehouseCode() {
      if (this.form.customerId && this.fbaJob.serviceChannel && this.form.chargeWeight && this.form.chargeWeight > 0) {
        await this.$confirm(this.$t('FbaJob.changeWarehouseCode'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
    },
    placeholderSFT(i) {
      return JobUtils.placeholderSFT(this.isTP, i)
    },
    // 刷新费用
    async refreshCharge() {
      let authorizationValue = null
      let customers = []
      // 查找对应运价级别的客户
      for (const e of this.fbaQuotation.customerPriceList) {
        const item = { anyInteger: e.quotationObject }
        await searchCustomerPrice(item).then(res => {
          const result = res.data || []
          customers = customers.concat(result)
        })
      }
      if (customers && customers.length > 0) {
        for (const customer of customers) {
          if (Number(this.form.customerId) === Number(customer.CMP_IDX)) {
            authorizationValue = customer.AUTHORIZATION_VALUE
            break
          }
        }
      }
      if (authorizationValue) {
        const params = {
          fbaChannel: this.fbaChannel,
          fbaQuotation: this.fbaQuotation,
          quantity: this.form.quantityActual,
          weight: this.form.weightActual,
          cubage: this.form.cubageActual,
          volumetricWeight: this.form.volumetricWeight,
          chargeWeight: Number(this.form.chargeWeight),
          warehouseCode: this.fbaJob.warehouseCode,
          authorizationValue: authorizationValue
        }
        const fbaChargeInfo = FbaQuotationUtil.getFbaChargeInfo(params)
        if (fbaChargeInfo) {
          fbaChargeInfo.authorizationValue = authorizationValue
        }
        const fbaAdditionalChargeInfo = FbaQuotationUtil.getFbaAdditionalChargeInfo(params)
        if (fbaAdditionalChargeInfo) {
          fbaAdditionalChargeInfo.authorizationValue = authorizationValue
        }
        if (this.form.charges && this.form.charges.length > 0) {
          let matchCharge = false
          const chargeList = []
          let matchAdditionalCharge = false
          const additionalChargeList = []
          for (const item of this.form.charges) {
            if (fbaChargeInfo) {
              const chargeItemId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '海运费', 'itemId')
              if (item.chargeItemId === chargeItemId) {
                matchCharge = true
                chargeList.push(item)
              }
            }
            if (fbaAdditionalChargeInfo) {
              const chargeItemList = getCacheListByKey(basicCacheKeys.basic_data_ChargeItem)
              const matchList = chargeItemList.filter(p => (item.chargeItemId === p.itemId) && p.surcharge)
              if (matchList && matchList.length > 0) {
                matchAdditionalCharge = true
                additionalChargeList.push(item)
              }
            }
          }
          if (matchCharge) {
            this.updateCharge(fbaChargeInfo, chargeList)
          } else {
            await this.createCharge(fbaChargeInfo)
          }
          if (matchAdditionalCharge) {
            this.updateCharge(fbaAdditionalChargeInfo, additionalChargeList, true)
          } else {
            await this.createCharge(fbaAdditionalChargeInfo, true)
          }
        } else {
          if (fbaChargeInfo) {
            await this.createCharge(fbaChargeInfo)
          }
          if (fbaAdditionalChargeInfo) {
            await this.createCharge(fbaAdditionalChargeInfo, true)
          }
        }
      }
    },
    // 更新费用
    updateCharge(fbaChargeInfo, chargeList, additional = false) {
      for (const item of chargeList) {
        if (!item.confirmBillUuid &&
            !item.invoiceUuid && !item.billingUuid && !item.billingPaymentUuid &&
            !item.verifiedAmount && !item.paidOff && item.chargeState === 0 &&
            ((item.receivable && this.form.receivableChargeLockedStatus === 0) || (!item.receivable && this.form.payableChargeLockedStatus === 0))) {
          if (fbaChargeInfo) {
            item.chargeItemId = fbaChargeInfo.chargeItemId
            item.currency = fbaChargeInfo.currency
            item.quantity = fbaChargeInfo.quantity
            item.unitRate = fbaChargeInfo.unitRate
            item.amount = fbaChargeInfo.amount
            item.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
            item.measure = fbaChargeInfo.measure
            item.accountId = this.form.customerId
            ChargeUtils.calculateTax(item, item.quantity * item.unitRate, item.taxRate, true)
            ChargeUtils.getChargeisOverseaNotControlledByConfig(item)
            const localCurrency = RateUtil.localCurrencyByOffice()
            let remarks = ''
            if (additional) {
              remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
                  '费用类型：' + fbaChargeInfo.calcMethodStr + '\n' +
                  '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
                  '折合' + localCurrency + '：' + item.excludingTaxAmount
            } else {
              remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
                  '运价级别：' + ColumnUtils.QuotationObjectLabelFunc(Number(fbaChargeInfo.authorizationValue)) + '\n' +
                  '计费重量：' + this.form.chargeWeight + '\n' +
                  '计算方式：' + fbaChargeInfo.calcMethodStr + '\n' +
                  '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
                  '折合' + localCurrency + '：' + item.excludingTaxAmount
            }
            item.remarks = remarks
          }
        }
      }
      if (this.form.api) {
        this.form.api.refreshCells({ force: true })
      }
    },
    // 新增费用
    async createCharge(fbaChargeInfo, additional = false) {
      if (fbaChargeInfo) {
        const charge = new Charge().fillDefaultValue().getData()
        charge.chargeItemId = fbaChargeInfo.chargeItemId
        charge.currency = fbaChargeInfo.currency
        charge.quantity = fbaChargeInfo.quantity
        charge.unitRate = fbaChargeInfo.unitRate
        charge.amount = fbaChargeInfo.amount
        charge.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
        charge.measure = fbaChargeInfo.measure
        charge.accountId = this.form.customerId
        await BookingUtil.getNewCharge(charge, this.form, true)
        ChargeUtils.getChargeisOverseaNotControlledByConfig(charge)
        const localCurrency = RateUtil.localCurrencyByOffice()
        let remarks = ''
        if (additional) {
          remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
              '费用类型：' + fbaChargeInfo.calcMethodStr + '\n' +
              '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
              '折合' + localCurrency + '：' + charge.excludingTaxAmount
        } else {
          remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
              '运价级别：' + ColumnUtils.QuotationObjectLabelFunc(Number(fbaChargeInfo.authorizationValue)) + '\n' +
              '计费重量：' + this.form.chargeWeight + '\n' +
              '计算方式：' + fbaChargeInfo.calcMethodStr + '\n' +
              '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
              '折合' + localCurrency + '：' + charge.excludingTaxAmount
        }
        charge.remarks = remarks
        this.context.reloadCharge = true
      }
    },
    // 判断区中是否包含该目的地
    checkWarehouseCode() {
      let result = false
      if (this.fbaQuotation) {
        const partitionSettingList = this.fbaQuotation.partitionSettingList
        let warehouseCode = []
        for (const item of partitionSettingList) {
          const pod = item.pod
          if (pod && pod.split(',').length > 0) {
            warehouseCode = warehouseCode.concat(pod.split(','))
          }
        }
        result = warehouseCode.indexOf(this.fbaJob.warehouseCode) > -1
      }
      return result
    },
    // 判断可接货物是否包含当前货物类型
    async checkCargoType() {
      const acceptableGoodsStr = this.fbaQuotation.acceptableGoods
      let acceptableGoods = []
      if (acceptableGoodsStr && acceptableGoodsStr.split(',').length > 0) {
        acceptableGoods = acceptableGoodsStr.split(',')
      }
      if (acceptableGoods.indexOf(this.form.cargoType) === -1 && this.form.cargoType) {
        const acceptableGoodsTag = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_CargoType, 'code', this.form.cargoType, 'chineseName')
        await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), acceptableGoodsTag), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.form.cargoType = ''
      }
    },
    // 判断是否更新渠道
    async checkChangeChannel() {
      let customers = []
      let containCustomer = false
      // 查找对应运价级别的客户
      if (this.fbaQuotation) {
        for (const e of this.fbaQuotation.customerPriceList) {
          const item = { anyInteger: e.quotationObject }
          await searchCustomerPrice(item).then(res => {
            const result = res.data || []
            customers = customers.concat(result)
          })
        }
        if (customers && customers.length > 0) {
          for (const customer of customers) {
            if (Number(this.form.customerId) === Number(customer.CMP_IDX)) {
              containCustomer = true
              break
            }
          }
        }
      }
      return containCustomer
    },
    async changeChannelName(channelName) {
      const channel = this.channel4JobSelect.find(e => channelName === e.channelName)
      if (channel) {
        this.fbaChannel = channel
        this.fbaQuotation = new FbaQuotation().fillDefaultValue().getData()
        this.fbaQuotation.uuid = channel.quotationUuid
        const jobModel = new FbaQuotation(this.fbaQuotation)
        await jobModel.loadFbaQuotationRelated({
          quotation: true,
          label: true,
          partitionSetting: true,
          setupSetting: true,
          charge: true,
          customerPrice: true
        })
        this.form.fbaChannel = this.fbaChannel
        this.form.fbaQuotation = this.fbaQuotation
      } else {
        this.fbaChannel = null
        this.fbaQuotation = null
        this.form.fbaChannel = this.fbaChannel
        this.form.fbaQuotation = this.fbaQuotation
      }
    },
    bubbleSplittingRatioChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.BubbleSplittingRatio')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.bubbleSplittingRatio = this.bubbleSplittingRatio
      } else {
        if (this.fbaJob.bubbleSplittingRatio > 100) {
          this.fbaJob.bubbleSplittingRatio = 100
          this.bubbleSplittingRatio = 100
        } else {
          this.bubbleSplittingRatio = this.fbaJob.bubbleSplittingRatio
        }
      }
    },
    calcEstVolumetricAndChargeWeight(volumetricWeight) {
      if (!this.isFba) {
        return
      }
      const cubage = this.form.cubageContract * 1000000
      // 材积
      if (volumetricWeight && volumetricWeight > 0) {
        this.form.volumetricWeightContract = volumetricWeight
      } else {
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.fbaJob.chargingMethod) === 0) {
            this.form.volumetricWeightContract = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.form.volumetricWeightContract = (this.form.weightContract / 1000).toFixed(3)
          }
        }
      }
      // 计费重量
      const params = {
        fbaQuotation: this.fbaQuotation,
        chargingMethod: this.fbaJob.chargingMethod,
        quantity: this.form.quantityContract,
        weight: this.form.weightContract,
        cubage: this.form.cubageContract,
        volumetricWeight: this.form.volumetricWeightContract
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      if (this.form.quantityContract > 0 && this.form.weightContract > 0 && this.form.cubageContract > 0 && this.form.volumetricWeightContract > 0) {
        this.form.chargeWeightContract = Number(chargeWeight).toFixed(3)
      }
      this.form.volumetricWeightContract = Number(this.form.volumetricWeightContract).toFixed(3)
      this.form.chargeWeightContract = Number(this.form.chargeWeightContract).toFixed(3)
    },
    calcActVolumetricAndChargeWeight(volumetricWeight) {
      const cubage = this.form.cubageActual * 1000000
      // 材积
      if (volumetricWeight && volumetricWeight > 0) {
        this.form.volumetricWeight = volumetricWeight
      } else {
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.fbaJob.chargingMethod) === 0) {
            this.form.volumetricWeight = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.form.volumetricWeight = (this.form.weightActual / 1000).toFixed(3)
          }
        }
      }
      // 计费重量
      const params = {
        fbaQuotation: this.fbaQuotation,
        chargingMethod: this.fbaJob.chargingMethod,
        quantity: this.form.quantityActual,
        weight: this.form.weightActual,
        cubage: this.form.cubageActual,
        volumetricWeight: this.form.volumetricWeight
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      const refreshCharge = Number(chargeWeight) !== Number(this.form.chargeWeight)
      if (this.form.quantityActual > 0 && this.form.weightActual > 0 && this.form.cubageActual > 0 && this.form.volumetricWeight > 0) {
        this.form.chargeWeight = Number(chargeWeight).toFixed(3)
      }
      this.form.volumetricWeight = Number(this.form.volumetricWeight).toFixed(3)
      this.form.chargeWeight = Number(this.form.chargeWeight).toFixed(3)
      return refreshCharge
    },
    async changeVolumetricWeight() {
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight(this.form.volumetricWeight)
        if (refreshCharge) {
          await this.changeChargeWeight()
        }
      }
    },
    async changeChargeWeight() {
      if (this.isFba) {
        if (this.form.customerId && this.fbaJob.serviceChannel && this.form.chargeWeight && this.form.chargeWeight > 0) {
          await this.$confirm(this.$t('FbaJob.changeChargeWeight'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            cancelButtonText: this.$t('CargoMsg.Cargo_No'),
            type: 'warning'
          }).then(() => {
            // 刷新费用
            this.refreshCharge()
          }).catch(() => {
          })
        }
      }
    },
    // 目的地配送方式改变
    destinationDistributionChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.DestinationDistribution')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.destinationDistribution = this.destinationDistribution
      } else {
        this.destinationDistribution = this.fbaJob.destinationDistribution
        this.syncConsigneeInfo()
      }
    },
    // 改变计费方式
    chargingMethodChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.ChargingMethod')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.chargingMethod = this.chargingMethod
      } else {
        this.chargingMethod = this.fbaJob.chargingMethod
      }
    },
    getDefaultContact(contactList) {
      if (!contactList || contactList.length <= 0) return ''
      const c = contactList.find(item => item.defaultContact)
      return c || contactList[0]
    },
    async loadCustomerDetial(company) {
      let customer = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
      this.advancePaymentLabel = company && company.ifAdvancePayment ? this.$t('Partners.IfAdvancePayment') : ''
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      if (customer) {
        customer = new Customer(customer)
        const customerType = await customer.getCustomerType()
        // console.log('customerType', customerType)
        if (customerType) {
          this.customerLevel.level = customerType.typeId
          this.customerLevel.customerName = this.isZh ? customerType.chineseName : customerType.englishName
        }
      }
    },
    async etdChange(value) {
      await JobUtils.seEtdChange(this, value, this.form, this.context, this.isJyd)
    },
    async etaChange(value) {
      this.form.eta = value
      this.form.etaSailingDay = JobUtils.dateChange(this.form.eta)
    },
    async atdChange(value) {
      const oldValue = this.form.atd
      this.form.atd = value
      this.form.atdSailingDay = JobUtils.dateChange(this.form.atd)
      if (parseInt(this.config.get('syncSignDateBl')) === 1) {
        const cargoDocList = await new SeaExportJob(this.form).getSeaCargoDoc()
        for (const cargoDoc of cargoDocList) {
          const allow = (cargoDoc.docType === CargoDocConsts.MBL || cargoDoc.docType === CargoDocConsts.MBL2 ||
            cargoDoc.docType === CargoDocConsts.HBL || cargoDoc.docType === CargoDocConsts.HBL2 ||
            cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
            (oldValue && dateCompare(cargoDoc.signDateBL, oldValue) === 0))
          if (allow) {
            cargoDoc.signDateBL = this.form.atd
          }
        }
      }
      this.form.atdChanged = true
      if (this.form.usCustomsClearanceList && this.form.atd && !this.form.secondVesselETD) {
        syncAtdInfo(this.form.usCustomsClearanceList, this.form.atd)
      }
      if (value) {
        this.form.atdChangedDate = value
      }
    },
    async ataChange(value) {
      this.form.ata = value
      this.form.ataSailingDay = JobUtils.dateChange(this.form.ata)
      this.form.ataChanged = true
      if (this.form.usCustomsClearanceList && this.form.ata) {
        syncAtaInfo(this.form.usCustomsClearanceList, this.form.ata)
      }
    },
    onExChangeAgentChange(data) {
      this.form.exChangeAgent = data.value
      for (const item of this.form.dischargingTrucking) {
        item.exChangeAgent = data.value
      }
      this.context.modifiedData.dischargingTruckingInfo = this.form.dischargingTrucking
      CargoDocUtil.changeHBLAndHBL2AgentParty(this.form)
    },
    quantityActualChange() {
      SEUtils.changeQWCRule(null, () => {
        this.form.quantityContract = this.form.quantityActual
        ContainerUtil.refreshContainerUsageContractQwc(this.form, 'quantityContract')
      })
      this.pm.changeSynBillOfLadingQWC()
      this.pm.txtPackingChangeHandler()
      if (!this.slaveCustomsDeclarationEnable) { // 新模式下，只有关单信息变更才更新装箱信息
        this.pm.refContainerUsageQwc(2)
      }
      if (!this.form.multipleDischargingPickups && this.form.dischargingTrucking && this.form.dischargingTrucking.length > 0) {
        this.form.dischargingTrucking[0].quantity = this.form.quantityActual || 0
        this.context.modifiedData.dischargingTruckingInfo = this.form.dischargingTrucking
      }
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight()
        if (refreshCharge) {
          this.changeChargeWeight()
        }
      }
      // // 同步【件毛体】到【关单信息】
      // this.pm.syncQwcToPoItems()
    },
    async weightContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.pm.refreshWeightCharge(this.form, this.form.weightContract)
      }
      this.pm.jobContractQwcChange(2)
    },
    async weightActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.pm.refreshWeightCharge(this.form, this.form.weightActual)
      }
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.weightContract !== this.form.weightActual) {
          this.form.weightContract = this.form.weightActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.pm.refreshWeightCharge(this.form, this.form.weightContract)
          }
          ContainerUtil.refreshContainerUsageContractQwc(this.form, 'weightContract')
        }
      })
      if (!this.form.fba) {
        await this.pm.calculateChargeWeight()
      }
      if (!this.slaveCustomsDeclarationEnable) { // 新模式下，只有关单信息变更才更新装箱信息
        this.pm.refContainerUsageQwc(2)
      }
      if (!this.form.multipleDischargingPickups && this.form.dischargingTrucking && this.form.dischargingTrucking.length > 0) {
        this.form.dischargingTrucking[0].weight = this.form.weightActual || 0
        this.context.modifiedData.dischargingTruckingInfo = this.form.dischargingTrucking
      }
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight()
        if (refreshCharge) {
          this.changeChargeWeight()
        }
      }
      // // 同步【件毛体】到【关单信息】
      // this.pm.syncQwcToPoItems()
    },
    async cubageContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.pm.refreshCubageCharge(this.form, this.form.cubageContract)
      }
      this.pm.jobContractQwcChange(3)
    },
    async cubageActualChange() {
      await this.pm.refreshChargeByCubageActual(this.form, this.form.cubageActual)
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.cubageContract !== this.form.cubageActual) {
          this.form.cubageContract = this.form.cubageActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.pm.refreshCubageCharge(this.form, this.form.cubageContract)
          }
          this.form.chargeWeight = this.form.cubageActual
          ContainerUtil.refreshContainerUsageContractQwc(this.form, 'cubageContract')
        }
      })
      if (!this.form.fba) {
        await this.pm.calculateChargeWeight()
      }
      if (!this.slaveCustomsDeclarationEnable) { // 新模式下，只有关单信息变更才更新装箱信息
        this.pm.refContainerUsageQwc(2, false)
      }
      if (!this.form.multipleDischargingPickups && this.form.dischargingTrucking && this.form.dischargingTrucking.length > 0) {
        this.form.dischargingTrucking[0].cubage = this.form.cubageActual || 0
        this.context.modifiedData.dischargingTruckingInfo = this.form.dischargingTrucking
      }
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight()
        if (refreshCharge) {
          this.changeChargeWeight()
        }
      }
      // // 同步【件毛体】到【关单信息】
      // this.pm.syncQwcToPoItems()
    },
    transcribeCallback(data) {
      for (const key in data) {
        this.form[key] = data[key]
      }
    },
    showHsCodeSearchDialog(title, successCallback) {
      this.hsCodeSearchDialog.title = title
      this.hsCodeSearchDialog.successCallback = successCallback
      this.hsCodeSearchDialog.visible = true
    },
    warehouseNameChangeHandler(warehouseName) {
      if (this.form.warehouseInfo.length === 0) {
        return
      }
      const warehouseInfo = this.form.warehouseInfo[0]
      warehouseInfo.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        warehouseInfo.warehouseContactTel = w.warehouseContactTel
        warehouseInfo.warehouseContact = w.warehouseContact
        warehouseInfo.warehouseAddress = w.warehouseAddress
        warehouseInfo.mapFile = w.mapFile
        if (w.remarks) {
          warehouseInfo.remarks = w.remarks
        }
      } else {
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseAddress = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
      }
      this.pm.addWarehouseToModifiedSet(warehouseInfo)
    },
    async salesChange(data) {
      const form = this.form
      form.sales = data.value
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        form.salesOffice = data.defaultOfficeId
        form.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(this.form.salesOffice)
        this.salesOfficeText = office.chineseName
      } else {
        const user = new User(data)
        const department = user.getDefaultDepartment('role', 'sales')
        const office = Office.getOfficeByUuid(department.officeUuid)
        form.salesOffice = office.officeId
        form.salesDepartment = department.departmentId
        this.salesOfficeText = office.chineseName
      }
    },
    handleSurchargeTerms(data) {
      const surchargeTerms = this.form.surchargeTerms
      surchargeTerms.splice(0, surchargeTerms.length)
      surchargeTerms.push(...data)
      this.mergeSurchargeTerms()
    },
    mergeSurchargeTerms() {
      console.log(this.form.surchargeTerms)
      let text = ''
      for (const item of this.form.surchargeTerms) {
        if (item.deleted) {
          continue
        }
        if (text) {
          text += '\n'
        }
        const chargeItemName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'zhName')
        if (typeof chargeItemName === 'string' && chargeItemName.startsWith('HDS')) {
          this.form.hds = true
        }
        text += `${chargeItemName}：${item.terms}`
      }
      this.txtSurchargeTerms = text
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    async getSubmitData() {
      // CARGO-20365先触发富文本组件失焦事件去除尾部换行符
      if (this.$refs.cargoTextarea1) this.$refs.cargoTextarea1.hanldeFormat()
      if (this.$refs.cargoTextarea2) this.$refs.cargoTextarea2.hanldeFormat()
      this.form.masterJobNo = this.form.lclMaster ? this.form.lclMaster.jobNo : '' // // 主票新增小票的时候使用
      // CARGO-32200 变更基本页签唛头和英文品名时没有触发在此处会进行检查
      await this.pm.markBlurHandler()
      await this.pm.cargoEnglishNameBlurHandler()
      await this.validateForm()
      // 校验 装箱和基本页签的件毛体是否一致
      const msg = ContainerUtil.validateContainerUsage(this.form)
      if (msg) {
        throw new TabError(msg, 'tabBookingFCL')
      }

      if (this.form.customerContact) {
        for (const item of this.contactList) {
          if (item.contactPerson === this.form.customerContact) {
            this.form.contactEmail = item.email
          }
        }
      }
      // CARGO-23318 订舱页签的 主单号栏位 和SONO.栏位 保存数据时自动去除空格
      if (this.form.mbl) {
        this.form.mbl = this.form.mbl.trim()
      }
      if (this.form.soNo) {
        this.form.soNo = this.form.soNo.trim()
      }
      // HS CODE 基本页签录入过滤特殊字符（无论是否同步到提单，都需要保证job.hsCode合法）
      if (Number(this.config.get('SEHSCodeMode')) !== 1) {
        JobUtils.checkSpecialCharacters(this.form, 'hsCode')
      }
      JobUtils.checkSpecialCharacters(this.form, 'remarks')
      const job = { ...this.form }
      // 清空子表数据
      // for (const key in job) {
      //   if (typeof job[key] === 'object') {
      //     job[key] = undefined
      //   }
      // }
      const seaCargoDoc = []
      // 不管是否勾选MBL 保存的时候都要生成MBL记录
      // if (job.signMBL) {
      seaCargoDoc.push(this.mblDoc)
      // CARGO-16954 H5新版在基本页签修改信息之后会覆盖到MBL中的收发通信息【再cargo中未找到对应的逻辑】
      // 新增状态下CARGO勾选直单后，无论是否修改MBL收发通信息都会同步基本页签，目前与cargo保持一致
      const checkdMbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + this.form.lob)
      if (job.mblOnly && !job.uuid && !(this.action === 'copy' && checkdMbl)) {
        new SeaCargoDoc(this.mblDoc).copyBasicShipper(job)
        new SeaCargoDoc(this.mblDoc).copyBasicConsignee(job)
        new SeaCargoDoc(this.mblDoc).copyBasicNotify(job)
        await JobUtils.handlerCargoDocLinebreaks(this.mblDoc)
      }
      // CARGO-20179 自拼箱主票下直接新增小票 生成的HBL没有签发日期
      if (!job.masterFlag && !job.uuid) { // 新增小票
        if (parseInt(this.config.get('syncSignDateBl')) === 0) {
          if (this.hdoc && !this.hdoc.signDateBL) this.hdoc.signDateBL = job.etd
          if (this.mblDoc && !this.mblDoc.signDateBL) this.mblDoc.signDateBL = job.etd
        } else {
          if (this.hdoc && !this.hdoc.signDateBL) this.hdoc.signDateBL = job.atd
          if (this.mblDoc && !this.mblDoc.signDateBL) this.mblDoc.signDateBL = job.atd
        }
      }
      // 不管是否勾选HBL 保存的时候都要生成HBL记录
      seaCargoDoc.push(this.hdoc)
      // CARGO-16702 基本页签修改起运港目的港等信息，HBL拆单需要同步
      const cargoDocs = job.seaCargoDoc
      if (cargoDocs && cargoDocs.length > 0) {
        for (const item of cargoDocs) {
          if (item.state > 1 || item.releaseState === ReleaseState.ONSINGLERELEASE.code) continue
          if (((job.typeHBL === BillType.SPLIT_BILL_TYPE.code || job.typeHBL === BillType.MERGE_BILL_TYPE.code) && item.docType && item.docType === CargoDocConsts.HBL2) ||
            ((job.typeMBL === BillType.SPLIT_BILL_TYPE.code || job.typeMBL === BillType.MERGE_BILL_TYPE.code) && item.docType && item.docType === CargoDocConsts.MBL2)) {
            seaCargoDoc.push(item)
          }
        }
      }
      // 为了不点开并单页签也要入库数据
      const cargoDocList = await new SeaExportJob(this.form).getSeaCargoDoc()
      let mbl2Uuid = ''
      let mbl2Doc
      let hbl2Uuid = ''
      let hbl2Doc
      // 记录job是否已有并单
      for (const e of cargoDocList) {
        if (e.docType === 'MBL2') {
          mbl2Uuid = e.uuid
          mbl2Doc = e
        }
        if (e.docType === 'HBL2') {
          hbl2Uuid = e.uuid
          hbl2Doc = e
        }
      }
      if (job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
        let hasMergeMbl2 = false
        for (const e of seaCargoDoc) {
          if (e.docType === CargoDocConsts.MBL2) {
            hasMergeMbl2 = true
          }
        }
        if (!hasMergeMbl2) {
          let mbl2
          if (mbl2Uuid) {
            mbl2 = mbl2Doc
            mbl2.uuid = mbl2Uuid
          } else {
            mbl2 = new SeaCargoDoc().fillDefaultValue().getData()
            await this.initCargoDoc(mbl2, this.form, 'MBL2')
          }
          seaCargoDoc.push(mbl2)
        }
      } else if (mbl2Uuid) {
        // 提单种类修改为不是并单要删除并单记录
        mbl2Doc.delete = true
        seaCargoDoc.push(mbl2Doc)
      }
      if (job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
        let hasMergeHbl2 = false
        for (const e of seaCargoDoc) {
          if (e.docType === CargoDocConsts.HBL2) {
            hasMergeHbl2 = true
          }
        }
        if (!hasMergeHbl2) {
          let hbl2
          if (hbl2Uuid) {
            hbl2 = hbl2Doc
            hbl2.uuid = hbl2Uuid
          } else {
            hbl2 = await CargoDocUtil.onAddHbl2CargoDoc(null, this.form, this.hdoc)
          }
          seaCargoDoc.push(hbl2)
          cargoDocs.push(hbl2)
        }
      } else if (hbl2Uuid) {
        hbl2Doc.delete = true
        seaCargoDoc.push(hbl2Doc)
      }
      if (job.ams) {
        let amsDoc = await new SeaExportJob(this.form).getCargoDocByType('AMS', false)
        if (!amsDoc) {
          amsDoc = await CargoDocUtil.addAMS(this.form, true)
          amsDoc.jobUuid = this.form.uuid
          seaCargoDoc.push(amsDoc)
          // 加入到job对象中的变量
          cargoDocList.push(amsDoc)
        } else {
          await CargoDocUtil.fillNvoccScacAndEfNvoccScac(amsDoc)
        }
      }
      if (job.virtualHBL) {
        const hawb2List = cargoDocList.filter(p => p.docType === 'HAWB2')
        if (hawb2List.length > 0) {
          seaCargoDoc.push(...hawb2List)
        }
      }
      // CARGO-10762 【海运出口-海运订舱极速版】已装箱的小票，修改件毛体，未同步更新装箱件毛体
      let containerUsages = []
      if (this.form.lclMasterUuid && (!this.form.containers || this.form.containers.length <= 0) && this.form.containerUsages && this.form.containerUsages.length > 0) {
        containerUsages = this.form.containerUsages
      }

      // CARGO-21069 删除箱子后TEU，箱量未更新
      if (job.containerLoadType === 'BCF' || (job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code && this.isXy)) {
        const usefulSeaEQ = this.seaEqList.filter(p => !p.deleted)
        if (!usefulSeaEQ || usefulSeaEQ.length <= 0) {
          job.clearTeu = true
        }
      }
      if (this.form.containers) {
        for (const container of this.form.containers) {
          if (container.containerUsage) {
            for (const item of container.containerUsage) {
              if (item.poItems === '') {
                item.poItems = []
              }
              if (!item.ediContainers) {
                delete item.ediContainers
              }
            }
          }
        }
      }
      if (containerUsages && containerUsages.length > 0) {
        for (const usage of containerUsages) {
          if (usage.poItems === '') {
            usage.poItems = []
          }
          if (!usage.ediContainers) {
            delete usage.ediContainers
          }
        }
      }
      // fba业务
      const fbaJob = this.isFba ? { ...this.fbaJob } : null
      // 处理箱子相关信息
      if (this.$refs.customsDeclaration) {
        this.$refs.customsDeclaration.handleContainer()
      }
      if (seaCargoDoc) {
        for (const d of seaCargoDoc) {
          if (d.docType === CargoDocConsts.MBL || d.docType === CargoDocConsts.MBL2) {
            JobUtils.handlingSpecialCharactersForCargoDoc(d)
          }
        }
      }
      const submitData = {
        job,
        seaCargoDoc,
        seaEQ: this.seaEqList,
        delseaEQUuids: this.form.delseaEQUuids,
        cargoBulkDetailList: this.cargoBulkDetailList,
        containers: this.form.containers, // this.form.containers.filter(p => p.isDirty === true), // 实际件毛体 更改影响装箱数据未标记isDirty，后续根据需要再处理
        containerUsages: containerUsages,
        delContainerUuids: this.form.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.form.delContainerUsageUuids, // 删除的装箱uuid
        surchargeTerms: this.form.surchargeTerms,
        fbaJob, // fba业务
        isShowAcPaymentPlaceBL: this.pm.isShowAcPaymentPlaceBL,
        jobWarehouseNos: this.jobWarehouseNos
      }
      if (this.slaveCustomsDeclarationEnable) {
        submitData.delPoItemsUuids = this.delPoItemsUuids // 需要删除的 关单信息
        submitData.poItems = this.form.poItems.filter(p => !p.existInUsagedFlag) // 【关单信息】页签需要将这些已装箱的poItems排查掉，否则创建重复
      }
      if (this.loadingPortChanged || this.form.atdChanged || this.form.ataChanged) {
        submitData.usCustomsClearanceList = this.form.usCustomsClearanceList
      }
      return submitData
    },
    async validateForm() {
      const form = this.form
      if (form.customerId < 1) {
        throw new TabError(this.$t('Message.ConsignationCompanyCannotBeNull'), 'tabBookingFCL')
      }
      await JobUtils.checkCustomerBranchScope(form, 'tabBookingFCL')
      await SecurityUtil.companyisActive(this.$t('SeaExport.Customer'), form.customerId, 'tabBookingFCL')
      if (form.bookingAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.BookingAgent'), form.bookingAgent, 'tabBookingFCL')
      }
      if (form.destinationAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.DestinationAgent'), form.destinationAgent, 'tabBookingFCL', 'englishName')
      }
      if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && form.designationAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.NominatedAgent'), form.designationAgent, 'tabBookingFCL', 'englishName')
      }
      if (form.customsBroker) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.CustomsBroker'), form.customsBroker, 'tabBookingFCL')
      }
      if (form.warehouseCmp) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.Warehouse'), form.warehouseCmp, 'tabBookingFCL')
      }
      if (form.carryingCmp) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.HaulageCompany'), form.carryingCmp, 'tabBookingFCL')
      }
      if (form.carrierId) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.ShippingCompany'), form.carrierId, 'tabBookingFCL')
      }
      if (form.carrierAgentId) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.CarrierAgent'), form.carrierAgentId, 'tabBookingFCL')
      }
      if (!form.containerLoadType) {
        throw new TabError(this.$t('Message.FLCLTypeCannotBeNull'), 'tabBookingFCL')
      }
      if (!form.loadingPortCode || !this.checkSeaport(form.loadingPortCode)) {
        throw new TabError(this.$t('Message.POLCannotBeNull'), 'tabBookingFCL')
      }
      if (form.transfering && (!form.transferPortCode || !this.checkSeaport(form.transferPortCode))) {
        throw new TabError(this.$t('Message.IfThereIsATransferTheTransferPortCannotBeNull'), 'tabBookingFCL')
      }
      if (!form.dischargingPortCode || !this.checkSeaport(form.dischargingPortCode)) {
        throw new TabError(this.$t('Message.PortOfDischargeCannotBeNull'), 'tabBookingFCL')
      }
      if (!form.destinationPortCode || !this.checkSeaport(form.destinationPortCode)) {
        throw new TabError(this.$t('Message.PlaceOfDeliveryCannotBeNull'), 'tabBookingFCL')
      }
      if (form.cargoSource === 'SC' || parseInt(this.config.get('NorminationJobSaleType')) === 1) {
        if (!form.sales) {
          throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabBookingFCL')
        }
        if (!form.salesOffice) {
          throw new TabError(this.$t('Message.SalesBranchCompanyIsNullPleaseReSelectSales'), 'tabBookingFCL')
        }
        if (!form.salesDepartment) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBookingFCL')
        }
      } else {
        if (form.sales && !form.salesDepartment) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBookingFCL')
        }
      }
      if (!form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeNull'), 'tabBookingFCL')
      }
      if (form.etd && form.eta && form.eta < form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeLaterThanDateOfArrival'), 'tabBookingFCL')
      }
      if (form.cargoSource === 'NC' && !form.designationAgent) {
        throw new TabError(this.$t('Message.NominatedAgentCannotBeNull'), 'tabBookingFCL')
      }
      if (this.config.get('SERequirePONO') === '1' && !form.poNo) {
        throw new TabError(this.$t('Message.ItemNoCannotBeNull'), 'tabBookingFCL')
      }
      if (form.containerLoadType === 'FCL') {
        if (!this.seaEqList || this.seaEqList.length === 0) {
          throw new TabError(this.$t('Message.EQSizeCannotBeNull'), 'tabBookingFCL')
        }
      }
      // 判断销售是否是本人(新增订舱预审)
      if (form.jobState === -1) {
        const bookingIsOpenSaleCheck = parseInt(this.config.get('BookingIsOpenSaleCheck')) === 0
        if (form.sales !== this.$store.getters.userInfo.userId && !bookingIsOpenSaleCheck) {
          throw new TabError(this.$t('Message.DearYouCanOnlySelectYourOwnCustomers'), 'tabBookingFCL')
        }
      }
      if (!form.opDepartment) {
        throw new TabError(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'), 'tabBookingFCL')
      }
      if ((form.containerLoadType === 'FCL' || form.containerLoadType === 'BB' || form.containerLoadType === 'BCF') && this.seaEqList && this.seaEqList.length > 0) {
        if (!form.seaEQ) form.seaEQ = this.seaEqList
        if (ContainerUtil.checkQuantityFromSeaEQ(form) && parseInt(this.config.get('BoxQuantityEmptyControl')) === 0) {
          throw new TabError(
            this.$t('SeaExport.CartonQuantityCannotBeZero'),
            'tabBookingFCL'
          )
        }
        if (ContainerUtil.checkNoDuplationSeaEQ(form)) {
          throw new TabError(this.$t('SeaExport.RepeatBoxType'), 'tabBookingFCL')
        }
      }
      if (!SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
        throw new TabError(this.$t('CargoMsg.Cargo_CustomerNotOwn'), 'tabBookingFCL')
      }
      // 海运头程 保存校验
      if (this.isFba && this.fbaJob) {
        if (!this.fbaJob.preWarehousingTime) {
          throw new TabError(this.$t('SeaExport.EstimatedTimeCannotBeEmpty'), 'tabBookingFCL')
        }
        if (!this.fbaJob.warehouseCode) {
          throw new TabError(this.$t('SeaExport.DestinationCannotBeEmpty'), 'tabBookingFCL')
        }
        if (!this.fbaJob.country) {
          throw new TabError(this.$t('SeaExport.DestinationCountryCannotBeEmpty'), 'tabBookingFCL')
        }
        if (!this.fbaJob.zipCode) {
          throw new TabError(this.$t('SeaExport.ZipCodeCannotBeEmpty'), 'tabBookingFCL')
        }
        if (!this.fbaJob.chargingMethod && this.fbaJob.chargingMethod !== 0) {
          throw new TabError(this.$t('FbaJob.ChargingMethod') + this.$t('SeaExport.CannotBeEmpty'), 'tabBookingFCL')
        }
      }
      // 中邮定制字段 保存校验
      if (this.isZY && !form.saleProductCode) {
        throw new TabError(this.$t('Message.SaleProductCodeCannotBeNull'), 'tabBookingFCL')
      }
      if (this.isZY && !form.fullOrInside) {
        throw new TabError(this.$t('Message.FullOrInsideCannotBeNull'), 'tabBookingFCL')
      }
      // 参数开启 且 页面加载过poItems数据（针对小票）
      if (this.slaveCustomsDeclarationEnable) {
        // 至少需要一条【关单信息】
        if (!this.form.poItems || this.form.poItems.length === 0) {
          throw new TabError(this.$t('CargoMsg.Cargo_CustomsDeclarationNotExist'), 'tabBookingFCL')
        }

        let soNoRepeat = false
        const soNoSet = new Set()
        for (const poItem of this.form.poItems) {
          if (!poItem.quantity || !poItem.grossWeight || !poItem.cubage) {
            throw new TabError(this.$t('CargoMsg.Cargo_CustomsDeclarationValidTip'), 'tabBookingFCL')
          }
          if (!soNoRepeat && poItem.soNo) {
            if (soNoSet.has(poItem.soNo)) {
              soNoRepeat = true
            } else {
              soNoSet.add(poItem.soNo)
            }
          }
        }
        if (soNoRepeat) {
          throw new TabError(this.$t('CargoMsg.Cargo_CustomsDeclarationSoNoRepeat'), 'tabBookingFCL')
        }

        // （多so场景存在；单票场景会互相同步，不会出现不一致问题）【关单信息】与【业务件毛体】不一致时，需要进行同步
        let totalQuantity = 0
        let totalWeight = 0
        let totalCubage = 0
        for (const poItem of this.form.poItems) {
          totalQuantity += Number(poItem.quantity) || 0
          totalWeight += Number(poItem.grossWeight) || 0
          totalCubage += Number(poItem.cubage) || 0
        }
        totalWeight = NumberUtils.formatNumber(totalWeight, 3, true)
        totalCubage = NumberUtils.formatNumber(totalCubage, 3, true)
        if ((Number(totalQuantity) || 0) !== (Number(this.form.quantityActual) || 0) ||
          (Number(totalWeight) || 0) !== (Number(this.form.weightActual) || 0) ||
          (Number(totalCubage) || 0) !== (Number(this.form.cubageActual) || 0)) {
          const messages = []
          const createElement = this.$createElement
          messages.push(createElement('p', null, this.$t('CargoMsg.Cargo_QuantityWeightCubageChange')))
          messages.push(createElement('p', null, this.$t('SeaExport.QuantityActual') + ' : ' + totalQuantity + '----->' + Number(this.form.quantityActual) || 0))
          messages.push(createElement('p', null, this.$t('SeaExport.WeightActual') + ' : ' + totalWeight + '----->' + NumberUtils.formatNumber((Number(this.form.weightActual) || 0), 3, true)))
          messages.push(createElement('p', null, this.$t('SeaExport.CubageActual') + ' : ' + totalCubage + '----->' + NumberUtils.formatNumber((Number(this.form.cubageActual) || 0), 3, true)))
          return await this.$confirm(createElement('div', null, messages), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('constant.yes'),
            cancelButtonText: this.$t('constant.no'),
            closeOnClickModal: false,
            type: 'info'
          }).then(async() => {
            if (this.form.quantityActual !== totalQuantity) {
              this.form.quantityActual = totalQuantity
              this.quantityActualChange()
            }
            if (this.form.weightActual !== totalWeight) {
              this.form.weightActual = totalWeight
              await this.weightActualChange()
            }
            if (this.form.cubageActual !== totalCubage) {
              this.form.cubageActual = totalCubage
              await this.cubageActualChange()
            }
            return true
          }).catch(() => {
            throw new TabError(this.$t('CargoMsg.Cargo_QuantityWeightCubageChange'), 'tabBookingFCL')
          })
        }
      }
    },
    // 校验海港
    checkSeaport(code) {
      const obj = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', code)
      return Boolean(obj)
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      // const reqKeys = this.getRequestSelectedKeys()
      // params.REQUEST_UUID = (!reqKeys || reqKeys.length === 0 ? '' : reqKeys)
      PrintTemplateUtil.buildPrintDataByBooking(this.form, params)
      params.category = 'BOOKING'
      params.ctx = new SeaExportJob(this.form)
      // this.$logger.log('params', params)
      return params
      // TemplateSelectorWin.getInstance().showThisWin(job, "BOOKING", params, view, null, doPrintCallBackV1);
    },
    // 打印回调
    printedCallback(event) {
      this.$logger.log(event)
      const template = event.template
      const documentType = event.documentType
      if (template && documentType) {
        const objParams = { jobUuid: this.form.uuid, docKeys: documentType.uuid }
        this.$logger.log(objParams)
        updateTrackingForDocumentType(objParams)
      }
    },
    /**
     * 客户特殊要求
     */
    getRequestSelectedKeys() {
      return this.$refs['selectedSpecialRequest'].getRequestSelectedKeys() || []
    },
    endTabHandler() {
      this.pm.fillModel()
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
      // this.$nextTick(() => {
      //   const shipper = from.startsWith('shipperLine')
      //   const consignee = from.startsWith('consigneeLine')
      //   const notify = from.startsWith('notifyLine')
      //   this.pm.syncDocSft(shipper, consignee, notify)
      // })
    },
    executeTask() {
      // 保存客户发运信息
      this.addrPM.job = this.form
      this.addrPM.isPortFilter = true
      this.addrPM.shipperCodeField = ''
      this.addrPM.shipperField = 'shipperLine'
      this.addrPM.consigneeCodeField = ''
      this.addrPM.consigneeField = 'consigneeLine'
      this.addrPM.notifyCodeField = ''
      this.addrPM.notifyField = 'notifyLine'
      this.addrPM.viewFromBasic = true
      if (parseInt(this.config.get('syncMailingAddress')) === 1) {
        this.addrPM.saveCheck()
      }
      this.delPoItemsUuids = []
    },
    eqQuantityChangeHandler() {
      ChargeUtils.eqQuantityChangeHandler(this.form, this.context)
    },
    fbaCodeSearchBtn() {
      if (!this.fbaJob || !this.fbaJob.customerId || Number(this.fbaJob.customerId) <= 0) {
        this.$message.warning(this.$t('SeaExport.PleaseTheConsignorUnitFirst'))
        return
      }
      this.fbaBillAddressDialog.visible = true
    },
    // fba收发通地址
    fbaCodeSearchCallback(data) {
      if (data.shipperInfo) {
        const curInfo = JobUtils.fbaHandleSft(data.shipperInfo, 'shipper')
        this.splitShipperLine(curInfo)
      }
      if (data.consigneeInfo) {
        const curInfo = JobUtils.fbaHandleSft(data.consigneeInfo, 'consignee')
        this.splitConsigneeLine(curInfo)
      }
      if (data.notifyInfo) {
        const curInfo = JobUtils.fbaHandleSft(data.notifyInfo, 'notify')
        this.splitNotifyLine(curInfo)
      }
    },
    // 客户属性过滤
    fbaCustomerIdFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customer && item.fba && item.active
    },
    onCargoEnglishNameChange() {
      if (this.mblDoc) {
        this.mblDoc._cargoEnglishNameTime = new Date()
      }
    },
    onMarkChange() {
      if (this.mblDoc) {
        this.mblDoc._markTime = new Date()
      }
    },
    async changeProject() {
      if (this.isProjectLinkedCustomer) {
        const company = await getPartnerByPoNo(this.form.poNo).then(res => {
          return res.data
        })
        if (company && company && this.form.customerId !== company.cmpIdx && company.active) {
          await this.customerIdChange2ContractHandler(company)
        }
      }
    },
    cargoTypeChange(data) {
      this.showCharacteristic = false
      if (data) {
        const cargoTypeMatch = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType).filter(p => p.sea && p.code === data)
        if (cargoTypeMatch && cargoTypeMatch.length > 0) {
          // 如果找到了，更新showCharacteristic属性
          this.showCharacteristic = cargoTypeMatch[0].showCharacteristics
        }
      }
      if (!data || !this.showCharacteristic) {
        this.form.electric = false
        this.form.magnetic = false
        this.form.powdery = false
        this.form.liquid = false
      }
      this.onCargoTypeChagne()
    },
    clearPoNo() {
      if (this.isProjectLinkedCustomer) {
        this.form.poNo = ''
        this.form.projectName = ''
      }
    },
    onCustomJobTypeChange() {
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
      this.form.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.form.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.form.customJobType, this.form.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.form.lob, this.form.containerLoadType, this.form.fba)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.form.opOffice = val
    },
    onCargoTypeChagne() {
      JobUtils.matchUserPortConfig(this, this.form)
    },
    // 合同规则相关字段切换时调用刷新【客户、指定货代理】信控信息
    contractRuleFieldChange(customerId, designationAgent) {
      this.pm.checkCredit()
      if (this.creditOpen) {
        // this.pm.checkCreditByCompany(customerId, 1)
        // this.pm.checkCreditByCompany(designationAgent, 2)
        this.pm.checkNewJobCreditInfo()
      }
    },
    destinationPortServiceChange(value) {
      // 取消勾选目的港服务,需要目的港服务下的勾选项目
      if (!value && !this.isFba) {
        this.form.dischargingPortDoor = false
        this.form.usCustomsClearance = false
        this.form.destPortCustomsClearance = false
      }
    },
    setOperationDateData() {
      this.operationDateData.fieldData = this.form.customsDate
      this.operationDateData.disabled = this.readonly
      console.log('主应用发送OperationDate:', this.operationDateData)
      microApp.forceSetData('child-operation-date', this.operationDateData)
    },
    operationDateDataChange(e) {
      console.log('主应用获取OperationDate:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setOperationDateData()
        } else {
          this.form.customsDate = e.detail.data.fieldData
        }
      }
    },
    setSaleRoleHideData() {
      console.log('主应用发送SaleRoleHide:', this.saleRoleHideData)
      microApp.forceSetData('child-sale-role-hide', this.saleRoleHideData)
    },
    saleRoleHideDataChange(e) {
      console.log('主应用获取SaleRoleHide:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setSaleRoleHideData()
        } else {
          this.saleRoleHide = e.detail.data.hide
        }
      }
    },
    setOperationDateQueryData() {
      console.log('主应用发送OperationDateQuery:', this.operationDateQuery)
      microApp.forceSetData('child-operation-date-query', this.operationDateQuery)
    },
    operationDateQueryDataChange(e) {
      console.log('主应用获取OperationDateQuery:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setOperationDateQueryData()
        } else {
          this.operationDateQuerySearch = e.detail.data.searchItem
          this.operationDateQueryColumn = e.detail.data.columnItem
        }
      }
    },
    setUserDefinedRoleData() {
      this.userDefinedRoleData.fieldData = this.form.userDefinedRoleId2 || ''
      this.userDefinedRoleData.disabled = this.readonly
      //
      this.userDefinedRoleData.filedLable = 'CargoMsg.Cargo_userDefinedRole2'
      this.userDefinedRoleData.no = 'userDefinedRoleId2'
      this.userDefinedRoleData.officeId = this.$store.getters.currentOfficeId
      this.userDefinedRoleData.category = 'role'
      this.userDefinedRoleData.shape = 'userDefinedRole2'
      this.userDefinedRoleData.staticOptions = this.userPortRoleData.userDefinedRole2
      this.userDefinedRoleData.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', this.userDefinedRoleData)
      microApp.forceSetData('child-user-defined-role', this.userDefinedRoleData)
    },
    userDefinedRoleDataChange(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleData()
        } else {
          this.form.userDefinedRoleId2 = e.detail.data.fieldData
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouseClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
<style lang="scss">

</style>
